export const vehicleTypeOptions = [
    { value: "car", label: "Car" },
    { value: "motorbike", label: "Motorbike" },
    { value: "van", label: "Van" },
    { value: "minivan", label: "Minivan" },
    { value: "pickup", label: "Pickup" },
    { value: "small_truck", label: "Small truck" },
    { value: "large_truck", label: "Large truck" },
]

export const bonusTypeOptions = [
    { value: "bonus", label: "Bonus" },
    { value: "deduction", label: "Deduction" }
]

export const MapStyleRoad = [
    {
        "featureType": "poi",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    }
];

export const MapStyleRetro = [
    {
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ebe3cd"
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#523735"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#f5f1e6"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#c9b2a6"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#dcd2be"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#ae9e90"
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e5dcc1"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dfd2ae"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#93817c"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#a5b076"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#447530"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f1e6"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#fdfcf8"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f8c967"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#e9bc62"
            }
        ]
    },
    {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e98d58"
            }
        ]
    },
    {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#db8555"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#806b63"
            }
        ]
    },
    {
        "featureType": "transit",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dfd2ae"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#8f7d77"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#ebe3cd"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dfd2ae"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#b9d3c2"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#92998d"
            }
        ]
    }
];

export const orderStatusTypes = [
    { color: '#000000', value: "all", label: "All" },
    { color: '#a4a4a4', value: "new_order", label: "New Order" },
    { color: '#a4a4a4', value: "processing", label: "Processing" },
    { color: '#f29817', value: "ready_for_delivery", label: "Ready for Delivery" },
    { color: '#a4a4a4', value: "picked_up", label: "Picked Up" },
    { color: '#a4a4a4', value: "intransit", label: "In Transit" },
    { color: '#5db050', value: "completed", label: "Completed" },
    { color: '#ea5034', value: "cancelled", label: "Cancelled" },
    { color: '#a4a4a4', value: "exception", label: "Exception" },
    { color: '#a4a4a4', value: "returned", label: "Returned" },
    { color: '#a4a4a4', value: "damaged_or_lost", label: "Damaged or Lost" },
    { color: '#a4a4a4', value: "not_ready_for_pickup", label: "Not Ready for Pickup" },
    { color: '#a4a4a4', value: "pickup_failed", label: "Pickup Failed" },
    { color: '#a4a4a4', value: "processing_at_warehouse", label: "Processing at Warehouse" },
    { color: '#a4a4a4', value: "in_warehouse", label: "In Warehouse" },
    { color: '#a4a4a4', value: "misrouted", label: "Misrouted" },
    { color: '#a4a4a4', value: "in_transit_to_warehouse", label: "In Transit to Warehouse" },
    { color: '#a4a4a4', value: "delivery_attempt_failed", label: "Delivery Attempt Failed" }
]

export const shipmentTypes = [
    { color: '#000000', value: "all", label: "All" },
    { color: '#f29817', value: "barq", label: "Barq" },
    { color: '#7c0202', value: "bullet", label: "Bullet" },
    { color: '#ff0000', value: "fast", label: "Fast" },
    { color: '#a4a4a4', value: "intercity", label: "Intercity" },
    { color: '#a4a4a4', value: "instant_delivery", label: "Instant Delivery" },
    { color: '#a4a4a4', value: "same_day", label: "Same Day" },
    { color: '#a4a4a4', value: "next_day", label: "Next Day" },
    { color: '#a4a4a4', value: "pick_up", label: "Pick Up" },
    { color: '#a4a4a4', value: "cold", label: "Cold" },
    { color: '#a4a4a4', value: "food", label: "Food" }
]

export const cityOptions = [
    {
        "id": 4, "name": "Makkah", "centerLat": 21.42251, "centerLng": 39.826168, "point1Lat": 21.585792, "point1Lng": 39.959998, "point2Lat": 21.265939, "point2Lng": 39.690553
    },
    {
        "id": 6, "name": "Jeddah", "centerLat": 21.543333, "centerLng": 39.172778, "point1Lat": 21.799732, "point1Lng": 39.294191, "point2Lat": 21.28548, "point2Lng": 39.055848
    },
    {
        "id": 9, "name": "Medinah", "centerLat": 24.468611, "centerLng": 39.614167, "point1Lat": 24.577232, "point1Lng": 39.73359, "point2Lat": 24.385714, "point2Lng": 39.510825
    },
    {
        "id": 1, "name": "Riyadh", "centerLat": 24.713552, "centerLng": 46.675296, "point1Lat": 25.127836, "point1Lng": 47.164391, "point2Lat": 24.406981, "point2Lng": 46.402778
    },
    {
        "id": 7, "name": "Tabouk", "centerLat": 28.40933, "centerLng": 36.56113, "point1Lat": 28.435, "point1Lng": 36.6, "point2Lat": 28.36, "point2Lng": 36.52
    },
    {
        "id": 14, "name": "Al Qassim", "centerLat": 26.333333, "centerLng": 43.966667, "point1Lat": 27.5, "point1Lng": 45, "point2Lat": 25, "point2Lng": 42.5
    },
    {
        "id": 13, "name": "Al Hofuf", "centerLat": 25.3638, "centerLng": 49.5891, "point1Lat": 25.43, "point1Lng": 49.65, "point2Lat": 25.3, "point2Lng": 49.52
    },
    {
        "id": 12, "name": "Yanbu", "centerLat": 24.0921, "centerLng": 38.0583, "point1Lat": 24.15, "point1Lng": 38.12, "point2Lat": 24.03, "point2Lng": 37.99
    },
    {
        "id": 11, "name": "Abha", "centerLat": 18.2167, "centerLng": 42.5053, "point1Lat": 18.28, "point1Lng": 42.57, "point2Lat": 18.15, "point2Lng": 42.44
    },
    {
        "id": 10, "name": "Najran", "centerLat": 17.4925, "centerLng": 44.1336, "point1Lat": 17.56, "point1Lng": 44.2, "point2Lat": 17.42, "point2Lng": 44.06
    },
    {
        "id": 8, "name": "Al Jubail", "centerLat": 27.0049, "centerLng": 49.6582, "point1Lat": 27.07, "point1Lng": 49.72, "point2Lat": 26.94, "point2Lng": 49.59
    },
    {
        "id": 5, "name": "Sakaka", "centerLat": 29.9698, "centerLng": 40.2064, "point1Lat": 30.03, "point1Lng": 40.27, "point2Lat": 29.9, "point2Lng": 40.14
    },
    {
        "id": 3, "name": "Jazan", "centerLat": 16.8893, "centerLng": 42.551, "point1Lat": 16.95, "point1Lng": 42.61, "point2Lat": 16.82, "point2Lng": 42.49
    },
    {
        "id": 2, "name": "Dammam", "centerLat": 26.4344, "centerLng": 50.1033, "point1Lat": 26.5, "point1Lng": 50.17, "point2Lat": 26.37, "point2Lng": 50.04
    },
    {
        "id": 15, "name": "Al Medina", "centerLat": 24.468611, "centerLng": 39.614167, "point1Lat": 24.577232, "point1Lng": 39.73359, "point2Lat": 24.385714, "point2Lng": 39.510825
    },
    {
        "id": 16, "name": "Taif", "centerLat": 21.2702, "centerLng": 40.4158, "point1Lat": 21.34, "point1Lng": 40.48, "point2Lat": 21.2, "point2Lng": 40.35
    },
    {
        "id": 19, "name": "Ad Dilam", "centerLat": 23.9936, "centerLng": 47.1611, "point1Lat": 24.05, "point1Lng": 47.22, "point2Lat": 23.93, "point2Lng": 47.1
    },
    {
        "id": 20, "name": "Ad Diriyah", "centerLat": 24.7578, "centerLng": 46.576, "point1Lat": 24.82, "point1Lng": 46.64, "point2Lat": 24.69, "point2Lng": 46.51
    },
    {
        "id": 21, "name": "Ahad Rufaidah", "centerLat": 18.1969, "centerLng": 42.8256, "point1Lat": 18.25, "point1Lng": 42.88, "point2Lat": 18.13, "point2Lng": 42.76
    },
    {
        "id": 22, "name": "Qatif", "centerLat": 26.5714, "centerLng": 49.9961, "point1Lat": 26.63, "point1Lng": 50.05, "point2Lat": 26.51, "point2Lng": 49.93
    },
    {
        "id": 23, "name": "Ad Dubaiyah", "centerLat": 26.116667, "centerLng": 49.633333, "point1Lat": 26.13, "point1Lng": 49.65, "point2Lat": 26.1, "point2Lng": 49.61
    },
    {
        "id": 24, "name": "Qasab", "centerLat": 25.352, "centerLng": 45.419, "point1Lat": 25.37, "point1Lng": 45.44, "point2Lat": 25.33, "point2Lng": 45.39
    },
    {
        "id": 25, "name": "Turaif", "centerLat": 31.6747, "centerLng": 38.6534, "point1Lat": 31.73, "point1Lng": 38.71, "point2Lat": 31.61, "point2Lng": 38.59
    },
    {
        "id": 26, "name": "Ain Al Nakhal", "centerLat": 24.786, "centerLng": 39.513, "point1Lat": 24.8, "point1Lng": 39.53, "point2Lat": 24.76, "point2Lng": 39.49
    },
    {
        "id": 27, "name": "Rafha", "centerLat": 29.6269, "centerLng": 43.5042, "point1Lat": 29.68, "point1Lng": 43.56, "point2Lat": 29.56, "point2Lng": 43.44
    },
    {
        "id": 28, "name": "Rania", "centerLat": 21.2869, "centerLng": 42.8464, "point1Lat": 21.34, "point1Lng": 42.9, "point2Lat": 21.22, "point2Lng": 42.78
    },
    {
        "id": 29, "name": "Al Dughaimiyah", "centerLat": 24.73333, "centerLng": 39.11667, "point1Lat": 24.75, "point1Lng": 39.14, "point2Lat": 24.71, "point2Lng": 39.09
    },
    {
        "id": 30, "name": "Al Jubaylah", "centerLat": 24.96694, "centerLng": 46.43806, "point1Lat": 24.98, "point1Lng": 46.46, "point2Lat": 24.94, "point2Lng": 46.41
    },
    {
        "id": 31, "name": "Hafar Al-batin", "centerLat": 28.435, "centerLng": 45.968, "point1Lat": 28.5, "point1Lng": 46.03, "point2Lat": 28.37, "point2Lng": 45.9
    },
    {
        "id": 32, "name": "Buraidah", "centerLat": 26.326, "centerLng": 43.975, "point1Lat": 26.39, "point1Lng": 44.04, "point2Lat": 26.26, "point2Lng": 43.91
    },
    {
        "id": 33, "name": "Khobar", "centerLat": 26.2842, "centerLng": 50.2109, "point1Lat": 26.35, "point1Lng": 50.27, "point2Lat": 26.22, "point2Lng": 50.15
    },
    {
        "id": 34, "name": "AL KHARJ", "centerLat": 24.1574, "centerLng": 47.3101, "point1Lat": 24.22, "point1Lng": 47.37, "point2Lat": 24.09, "point2Lng": 47.25
    },
    {
        "id": 35, "name": "Al Majmaah", "centerLat": 25.9036, "centerLng": 45.3475, "point1Lat": 25.96, "point1Lng": 45.41, "point2Lat": 25.84, "point2Lng": 45.28
    },
    {
        "id": 36, "name": "Dawadmi", "centerLat": 24.5074, "centerLng": 44.3977, "point1Lat": 24.57, "point1Lng": 44.46, "point2Lat": 24.44, "point2Lng": 44.33
    },
    {
        "id": 37, "name": "Wadi El Dwaser", "centerLat": 20.4667, "centerLng": 44.7833, "point1Lat": 20.53, "point1Lng": 44.85, "point2Lat": 20.4, "point2Lng": 44.71
    },
    {
        "id": 38, "name": "Al Muzahimiyah", "centerLat": 24.483, "centerLng": 46.275, "point1Lat": 24.54, "point1Lng": 46.33, "point2Lat": 24.42, "point2Lng": 46.21
    },
    {
        "id": 39, "name": "Al Quwaiiyah", "centerLat": 24.05, "centerLng": 45.25, "point1Lat": 24.11, "point1Lng": 45.31, "point2Lat": 23.99, "point2Lng": 45.19
    },
    {
        "id": 40, "name": "Al Uyaynah", "centerLat": 24.89, "centerLng": 46.37, "point1Lat": 24.95, "point1Lng": 46.43, "point2Lat": 24.83, "point2Lng": 46.31
    },
    {
        "id": 41, "name": "Al'asyah", "centerLat": 26.6853, "centerLng": 43.6828, "point1Lat": 26.74, "point1Lng": 43.74, "point2Lat": 26.62, "point2Lng": 43.62
    },
    {
        "id": 42, "name": "Al badayie", "centerLat": 26.0028, "centerLng": 43.7028, "point1Lat": 26.06, "point1Lng": 43.76, "point2Lat": 25.94, "point2Lng": 43.64
    },
    {
        "id": 44, "name": "Aldarb", "centerLat": 17.722, "centerLng": 42.257, "point1Lat": 17.78, "point1Lng": 42.32, "point2Lat": 17.66, "point2Lng": 42.19
    },
    {
        "id": 45, "name": "Alrass", "centerLat": 25.8697, "centerLng": 43.5019, "point1Lat": 25.93, "point1Lng": 43.56, "point2Lat": 25.8, "point2Lng": 43.44
    },
    {
        "id": 46, "name": "Anak", "centerLat": 26.5414, "centerLng": 49.9708, "point1Lat": 26.56, "point1Lng": 49.99, "point2Lat": 26.52, "point2Lng": 49.95
    },
    {
        "id": 47, "name": "Arar", "centerLat": 30.9754, "centerLng": 41.0381, "point1Lat": 31.04, "point1Lng": 41.1, "point2Lat": 30.91, "point2Lng": 40.97
    },
    {
        "id": 48, "name": "Buqayq", "centerLat": 25.935, "centerLng": 49.6672, "point1Lat": 25.99, "point1Lng": 49.73, "point2Lat": 25.87, "point2Lng": 49.6
    },
    {
        "id": 49, "name": "Euyun aljiwa", "centerLat": 26.5819, "centerLng": 43.6669, "point1Lat": 26.64, "point1Lng": 43.73, "point2Lat": 26.52, "point2Lng": 43.6
    },
    {
        "id": 50, "name": "Hautat Sudair", "centerLat": 25.626, "centerLng": 45.617, "point1Lat": 25.68, "point1Lng": 45.68, "point2Lat": 25.56, "point2Lng": 45.55
    },
    {
        "id": 51, "name": "Jalajil", "centerLat": 25.6667, "centerLng": 45.4833, "point1Lat": 25.72, "point1Lng": 45.54, "point2Lat": 25.6, "point2Lng": 45.42
    },
    {
        "id": 52, "name": "Hinakeya", "centerLat": 24.87, "centerLng": 40.54, "point1Lat": 24.93, "point1Lng": 40.6, "point2Lat": 24.81, "point2Lng": 40.48
    },
    {
        "id": 53, "name": "Al Hassa", "centerLat": 25.3833, "centerLng": 49.5833, "point1Lat": 25.6, "point1Lng": 49.8, "point2Lat": 25.2, "point2Lng": 49.4
    },
    {
        "id": 54, "name": "Dhahran", "centerLat": 26.3019, "centerLng": 50.1558, "point1Lat": 26.36, "point1Lng": 50.22, "point2Lat": 26.24, "point2Lng": 50.09
    },
    {
        "id": 55, "name": "Khamis Mushait", "centerLat": 18.3, "centerLng": 42.7333, "point1Lat": 18.36, "point1Lng": 42.8, "point2Lat": 18.24, "point2Lng": 42.67
    },
    {
        "id": 56, "name": "Jilah", "centerLat": 23.516667, "centerLng": 47.933333, "point1Lat": 23.53, "point1Lng": 47.95, "point2Lat": 23.5, "point2Lng": 47.91
    },
    {
        "id": 57, "name": "Qaysoomah", "centerLat": 28.31, "centerLng": 46.129, "point1Lat": 28.37, "point1Lng": 46.19, "point2Lat": 28.25, "point2Lng": 46.06
    },
    {
        "id": 58, "name": "Tanuma", "centerLat": 18.995, "centerLng": 42.176, "point1Lat": 19.05, "point1Lng": 42.24, "point2Lat": 18.93, "point2Lng": 42.11
    },
    {
        "id": 59, "name": "Nwariah", "centerLat": 21.5794, "centerLng": 39.919, "point1Lat": 21.6, "point1Lng": 39.94, "point2Lat": 21.55, "point2Lng": 39.89
    },
    {
        "id": 60, "name": "Mahayel Aseer", "centerLat": 18.547, "centerLng": 42.046, "point1Lat": 18.6, "point1Lng": 42.1, "point2Lat": 18.48, "point2Lng": 41.98
    },
    {
        "id": 61, "name": "Malham", "centerLat": 25.137, "centerLng": 46.398, "point1Lat": 25.19, "point1Lng": 46.46, "point2Lat": 25.07, "point2Lng": 46.33
    },
    {
        "id": 62, "name": "Marat", "centerLat": 25.076, "centerLng": 45.419, "point1Lat": 25.13, "point1Lng": 45.48, "point2Lat": 25.01, "point2Lng": 45.35
    },
    {
        "id": 63, "name": "New Ain Dar", "centerLat": 25.9922, "centerLng": 49.378, "point1Lat": 26.01, "point1Lng": 49.4, "point2Lat": 25.97, "point2Lng": 49.35
    },
    {
        "id": 64, "name": "Old Ain Dar", "centerLat": 26.071, "centerLng": 49.435, "point1Lat": 26.09, "point1Lng": 49.46, "point2Lat": 26.05, "point2Lng": 49.41
    },
    {
        "id": 65, "name": "RAS TANURA", "centerLat": 26.65, "centerLng": 50.158, "point1Lat": 26.71, "point1Lng": 50.22, "point2Lat": 26.59, "point2Lng": 50.09
    },
    {
        "id": 66, "name": "Raudat Sudair", "centerLat": 25.753, "centerLng": 45.548, "point1Lat": 25.81, "point1Lng": 45.61, "point2Lat": 25.69, "point2Lng": 45.48
    },
    {
        "id": 67, "name": "Safwa", "centerLat": 26.6569, "centerLng": 49.9722, "point1Lat": 26.71, "point1Lng": 50.03, "point2Lat": 26.59, "point2Lng": 49.91
    },
    {
        "id": 68, "name": "Saihat", "centerLat": 26.478, "centerLng": 50.039, "point1Lat": 26.53, "point1Lng": 50.1, "point2Lat": 26.41, "point2Lng": 49.97
    },
    {
        "id": 69, "name": "Salbukh", "centerLat": 25.068, "centerLng": 46.223, "point1Lat": 25.12, "point1Lng": 46.28, "point2Lat": 25, "point2Lng": 46.16
    },
    {
        "id": 70, "name": "Tarout", "centerLat": 26.568, "centerLng": 50.063, "point1Lat": 26.62, "point1Lng": 50.12, "point2Lat": 26.5, "point2Lng": 50
    },
    {
        "id": 71, "name": "Thadiq", "centerLat": 25.292, "centerLng": 45.86, "point1Lat": 25.35, "point1Lng": 45.92, "point2Lat": 25.23, "point2Lng": 45.8
    },
    {
        "id": 72, "name": "Tharmda", "centerLat": 25.263, "centerLng": 45.541, "point1Lat": 25.32, "point1Lng": 45.6, "point2Lat": 25.2, "point2Lng": 45.48
    },
    {
        "id": 73, "name": "Tumair", "centerLat": 25.7, "centerLng": 45.8833, "point1Lat": 25.76, "point1Lng": 45.94, "point2Lat": 25.64, "point2Lng": 45.82
    },
    {
        "id": 74, "name": "Unaizah", "centerLat": 26.0906, "centerLng": 43.9786, "point1Lat": 26.15, "point1Lng": 44.04, "point2Lat": 26.03, "point2Lng": 43.91
    },
    {
        "id": 75, "name": "Ushairat Sudair", "centerLat": 25.564, "centerLng": 45.452, "point1Lat": 25.58, "point1Lng": 45.47, "point2Lat": 25.54, "point2Lng": 45.43
    },
    {
        "id": 76, "name": "Wadi Ibn Hashbel", "centerLat": 18.508, "centerLng": 42.923, "point1Lat": 18.56, "point1Lng": 42.98, "point2Lat": 18.44, "point2Lng": 42.86
    },
    {
        "id": 77, "name": "zulfi", "centerLat": 26.297, "centerLng": 44.802, "point1Lat": 26.35, "point1Lng": 44.86, "point2Lat": 26.23, "point2Lng": 44.74
    },
    {
        "id": 78, "name": "Abqaiq", "centerLat": 25.935, "centerLng": 49.6672, "point1Lat": 25.99, "point1Lng": 49.73, "point2Lat": 25.87, "point2Lng": 49.6
    },
    {
        "id": 79, "name": "Abu Arish Governorate", "centerLat": 16.9692, "centerLng": 42.8278, "point1Lat": 17, "point1Lng": 42.86, "point2Lat": 16.94, "point2Lng": 42.8
    },
    {
        "id": 80, "name": "Dhurma", "centerLat": 24.695, "centerLng": 46.143, "point1Lat": 24.75, "point1Lng": 46.2, "point2Lat": 24.63, "point2Lng": 46.08
    },
    {
        "id": 81, "name": "Howtat Bani Tamim", "centerLat": 23.483, "centerLng": 46.758, "point1Lat": 23.54, "point1Lng": 46.82, "point2Lat": 23.42, "point2Lng": 46.69
    },
    {
        "id": 82, "name": "Shaqra", "centerLat": 25.247, "centerLng": 45.253, "point1Lat": 25.3, "point1Lng": 45.31, "point2Lat": 25.18, "point2Lng": 45.19
    },
    {
        "id": 83, "name": "Huraymila", "centerLat": 25.048, "centerLng": 46.155, "point1Lat": 25.1, "point1Lng": 46.21, "point2Lat": 24.98, "point2Lng": 46.09
    },
    {
        "id": 84, "name": "Qurayat", "centerLat": 31.332, "centerLng": 37.361, "point1Lat": 31.39, "point1Lng": 37.42, "point2Lat": 31.27, "point2Lng": 37.3
    },
    {
        "id": 85, "name": "Qunfudah", "centerLat": 19.128, "centerLng": 41.078, "point1Lat": 19.18, "point1Lng": 41.14, "point2Lat": 19.06, "point2Lng": 41.01
    },
    {
        "id": 86, "name": "Dumat Al Jandal", "centerLat": 29.811, "centerLng": 39.868, "point1Lat": 29.87, "point1Lng": 39.93, "point2Lat": 29.75, "point2Lng": 39.8
    },
    {
        "id": 87, "name": "Hafar Al Batin", "centerLat": 28.435, "centerLng": 45.968, "point1Lat": 28.5, "point1Lng": 46.03, "point2Lat": 28.37, "point2Lng": 45.9
    },
    {
        "id": 88, "name": "Al Bahah", "centerLat": 20.0129, "centerLng": 41.4677, "point1Lat": 20.07, "point1Lng": 41.53, "point2Lat": 19.95, "point2Lng": 41.4
    },
    {
        "id": 89, "name": "Mecca", "centerLat": 21.42251, "centerLng": 39.826168, "point1Lat": 21.585792, "point1Lng": 39.959998, "point2Lat": 21.265939, "point2Lng": 39.690553
    },
    {
        "id": 90, "name": "Medina", "centerLat": 24.468611, "centerLng": 39.614167, "point1Lat": 24.577232, "point1Lng": 39.73359, "point2Lat": 24.385714, "point2Lng": 39.510825
    },
    {
        "id": 91, "name": "Al Ahsa", "centerLat": 25.3833, "centerLng": 49.5833, "point1Lat": 25.6, "point1Lng": 49.8, "point2Lat": 25.2, "point2Lng": 49.4
    },
    {
        "id": 92, "name": "Al Qatif", "centerLat": 26.5714, "centerLng": 49.9961, "point1Lat": 26.63, "point1Lng": 50.05, "point2Lat": 26.51, "point2Lng": 49.93
    },
    {
        "id": 93, "name": "Almuzaylif", "centerLat": 19.529, "centerLng": 41.341, "point1Lat": 19.58, "point1Lng": 41.4, "point2Lat": 19.46, "point2Lng": 41.28
    },
    {
        "id": 94, "name": "Tabuk", "centerLat": 28.40933, "centerLng": 36.56113, "point1Lat": 28.435, "point1Lng": 36.6, "point2Lat": 28.36, "point2Lng": 36.52
    },
    {
        "id": 95, "name": "Al Mubarraz", "centerLat": 25.419, "centerLng": 49.59, "point1Lat": 25.47, "point1Lng": 49.65, "point2Lat": 25.35, "point2Lng": 49.53
    },
    {
        "id": 96, "name": "Duba", "centerLat": 27.351, "centerLng": 35.692, "point1Lat": 27.41, "point1Lng": 35.75, "point2Lat": 27.29, "point2Lng": 35.63
    },
    {
        "id": 97, "name": "Al Kharj", "centerLat": 24.1574, "centerLng": 47.3101, "point1Lat": 24.22, "point1Lng": 47.37, "point2Lat": 24.09, "point2Lng": 47.25
    },
    {
        "id": 98, "name": "Thuqbah", "centerLat": 26.2625, "centerLng": 50.1853, "point1Lat": 26.28, "point1Lng": 50.2, "point2Lat": 26.24, "point2Lng": 50.16
    },
    {
        "id": 99, "name": "Hawea/Taif", "centerLat": 21.4633, "centerLng": 40.4856, "point1Lat": 21.48, "point1Lng": 40.5, "point2Lat": 21.44, "point2Lng": 40.46
    },
    {
        "id": 100, "name": "Unayzah", "centerLat": 26.0906, "centerLng": 43.9786, "point1Lat": 26.15, "point1Lng": 44.04, "point2Lat": 26.03, "point2Lng": 43.91
    },
    {
        "id": 101, "name": "Al Khobar", "centerLat": 26.2842, "centerLng": 50.2109, "point1Lat": 26.35, "point1Lng": 50.27, "point2Lat": 26.22, "point2Lng": 50.15
    },
    {
        "id": 102, "name": "Al Qurayyat", "centerLat": 31.332, "centerLng": 37.361, "point1Lat": 31.39, "point1Lng": 37.42, "point2Lat": 31.27, "point2Lng": 37.3
    },
    {
        "id": 103, "name": "Az Zulfi", "centerLat": 26.297, "centerLng": 44.802, "point1Lat": 26.35, "point1Lng": 44.86, "point2Lat": 26.23, "point2Lng": 44.74
    },
    {
        "id": 104, "name": "Ar Rass", "centerLat": 25.8697, "centerLng": 43.5019, "point1Lat": 25.93, "point1Lng": 43.56, "point2Lat": 25.8, "point2Lng": 43.44
    },
    {
        "id": 105, "name": "Wadi ad-Dawasir", "centerLat": 20.4667, "centerLng": 44.7833, "point1Lat": 20.53, "point1Lng": 44.85, "point2Lat": 20.4, "point2Lng": 44.71
    },
    {
        "id": 106, "name": "Bishah", "centerLat": 19.9833, "centerLng": 42.6, "point1Lat": 20.04, "point1Lng": 42.66, "point2Lat": 19.92, "point2Lng": 42.54
    },
    {
        "id": 107, "name": "Sharorah", "centerLat": 17.478, "centerLng": 47.12, "point1Lat": 17.53, "point1Lng": 47.18, "point2Lat": 17.41, "point2Lng": 47.06
    },
    {
        "id": 108, "name": "Sabya", "centerLat": 17.151, "centerLng": 42.628, "point1Lat": 17.21, "point1Lng": 42.69, "point2Lat": 17.09, "point2Lng": 42.56
    },
    {
        "id": 109, "name": "Ahad Rafidah", "centerLat": 18.1969, "centerLng": 42.8256, "point1Lat": 18.25, "point1Lng": 42.88, "point2Lat": 18.13, "point2Lng": 42.76
    },
    {
        "id": 110, "name": "Al Furaysh", "centerLat": 24.3167, "centerLng": 39.2667, "point1Lat": 24.34, "point1Lng": 39.29, "point2Lat": 24.29, "point2Lng": 39.24
    },
    {
        "id": 111, "name": "Al Duwadimi", "centerLat": 24.5074, "centerLng": 44.3977, "point1Lat": 24.57, "point1Lng": 44.46, "point2Lat": 24.44, "point2Lng": 44.33
    },
    {
        "id": 112, "name": "Bariq", "centerLat": 18.93, "centerLng": 41.93, "point1Lat": 18.99, "point1Lng": 41.99, "point2Lat": 18.87, "point2Lng": 41.87
    },
    {
        "id": 113, "name": "Alhada", "centerLat": 21.353, "centerLng": 40.28, "point1Lat": 21.41, "point1Lng": 40.34, "point2Lat": 21.29, "point2Lng": 40.22
    },
    {
        "id": 114, "name": "Buraydah", "centerLat": 26.326, "centerLng": 43.975, "point1Lat": 26.39, "point1Lng": 44.04, "point2Lat": 26.26, "point2Lng": 43.91
    },
    {
        "id": 115, "name": "Al Mithnab", "centerLat": 25.867, "centerLng": 44.217, "point1Lat": 25.92, "point1Lng": 44.28, "point2Lat": 25.8, "point2Lng": 44.15
    },
    {
        "id": 116, "name": "Al Bukayriyah", "centerLat": 26.133, "centerLng": 43.65, "point1Lat": 26.19, "point1Lng": 43.71, "point2Lat": 26.07, "point2Lng": 43.59
    },
    {
        "id": 117, "name": "Al Badayea", "centerLat": 26.0028, "centerLng": 43.7028, "point1Lat": 26.06, "point1Lng": 43.76, "point2Lat": 25.94, "point2Lng": 43.64
    },
    {
        "id": 118, "name": "Al Hufuf and Al Mubarraz", "centerLat": 25.3888, "centerLng": 49.5891, "point1Lat": 25.45, "point1Lng": 49.65, "point2Lat": 25.32, "point2Lng": 49.52
    },
    {
        "id": 119, "name": "An Nabhaniyah", "centerLat": 25.33, "centerLng": 42.82, "point1Lat": 25.39, "point1Lng": 42.88, "point2Lat": 25.27, "point2Lng": 42.76
    },
    {
        "id": 120, "name": "Riyadh Al Khabra", "centerLat": 26.043, "centerLng": 43.618, "point1Lat": 26.1, "point1Lng": 43.68, "point2Lat": 25.98, "point2Lng": 43.55
    },
    {
        "id": 121, "name": "Ash Shimasiyah", "centerLat": 26.54, "centerLng": 44.38, "point1Lat": 26.6, "point1Lng": 44.44, "point2Lat": 26.48, "point2Lng": 44.32
    },
    {
        "id": 122, "name": "Al Ghat", "centerLat": 26.01, "centerLng": 44.97, "point1Lat": 26.07, "point1Lng": 45.03, "point2Lat": 25.95, "point2Lng": 44.91
    },
    {
        "id": 123, "name": "Uyun Al Jawa", "centerLat": 26.5819, "centerLng": 43.6669, "point1Lat": 26.64, "point1Lng": 43.73, "point2Lat": 26.52, "point2Lng": 43.6
    },
    {
        "id": 124, "name": "Sarat Abidah", "centerLat": 18.257, "centerLng": 43.123, "point1Lat": 18.31, "point1Lng": 43.18, "point2Lat": 18.19, "point2Lng": 43.06
    },
    {
        "id": 125, "name": "Afif", "centerLat": 23.906, "centerLng": 42.921, "point1Lat": 23.96, "point1Lng": 42.98, "point2Lat": 23.84, "point2Lng": 42.86
    },
    {
        "id": 126, "name": "DIRIYAH", "centerLat": 24.7578, "centerLng": 46.576, "point1Lat": 24.82, "point1Lng": 46.64, "point2Lat": 24.69, "point2Lng": 46.51
    },
    {
        "id": 127, "name": "As Sulayyil", "centerLat": 20.46, "centerLng": 45.57, "point1Lat": 20.52, "point1Lng": 45.63, "point2Lat": 20.4, "point2Lng": 45.51
    },
    {
        "id": 128, "name": "Rabigh", "centerLat": 22.8, "centerLng": 39.03, "point1Lat": 22.86, "point1Lng": 39.09, "point2Lat": 22.74, "point2Lng": 38.97
    },
    {
        "id": 129, "name": "Thuwal", "centerLat": 22.303, "centerLng": 39.102, "point1Lat": 22.36, "point1Lng": 39.16, "point2Lat": 22.24, "point2Lng": 39.04
    },
    {
        "id": 130, "name": "Al Qunfudhah", "centerLat": 19.128, "centerLng": 41.078, "point1Lat": 19.18, "point1Lng": 41.14, "point2Lat": 19.06, "point2Lng": 41.01
    },
    {
        "id": 131, "name": "Al Ula", "centerLat": 26.606, "centerLng": 37.92, "point1Lat": 26.66, "point1Lng": 37.98, "point2Lat": 26.54, "point2Lng": 37.86
    },
    {
        "id": 132, "name": "Al Lith", "centerLat": 20.147, "centerLng": 40.27, "point1Lat": 20.2, "point1Lng": 40.33, "point2Lat": 20.08, "point2Lng": 40.21
    },
    {
        "id": 133, "name": "Al Namas", "centerLat": 19.117, "centerLng": 42.133, "point1Lat": 19.17, "point1Lng": 42.19, "point2Lat": 19.05, "point2Lng": 42.07
    },
    {
        "id": 134, "name": "Baljurashi", "centerLat": 19.858, "centerLng": 41.56, "point1Lat": 19.91, "point1Lng": 41.62, "point2Lat": 19.79, "point2Lng": 41.5
    },
    {
        "id": 135, "name": "Al Makhwah", "centerLat": 19.78, "centerLng": 41.42, "point1Lat": 19.84, "point1Lng": 41.48, "point2Lat": 19.72, "point2Lng": 41.36
    },
    {
        "id": 136, "name": "Turbah", "centerLat": 21.215, "centerLng": 41.637, "point1Lat": 21.27, "point1Lng": 41.7, "point2Lat": 21.15, "point2Lng": 41.57
    },
    {
        "id": 137, "name": "Abu Arish", "centerLat": 16.9692, "centerLng": 42.8278, "point1Lat": 17, "point1Lng": 42.86, "point2Lat": 16.94, "point2Lng": 42.8
    },
    {
        "id": 138, "name": "Arish", "centerLat": 31.0368, "centerLng": 33.7997, "point1Lat": 31.1, "point1Lng": 33.86, "point2Lat": 30.97, "point2Lng": 33.73
    },
    {
        "id": 139, "name": "Khafji", "centerLat": 28.421, "centerLng": 48.5, "point1Lat": 28.48, "point1Lng": 48.56, "point2Lat": 28.36, "point2Lng": 48.44
    },
    {
        "id": 140, "name": "Al Khurma", "centerLat": 21.92, "centerLng": 42.06, "point1Lat": 21.98, "point1Lng": 42.12, "point2Lat": 21.86, "point2Lng": 42
    },
    {
        "id": 141, "name": "Hail", "centerLat": 27.525, "centerLng": 41.691, "point1Lat": 27.58, "point1Lng": 41.75, "point2Lat": 27.46, "point2Lng": 41.63
    },
    {
        "id": 142, "name": "Khurais", "centerLat": 25.07, "centerLng": 48.16, "point1Lat": 25.13, "point1Lng": 48.22, "point2Lat": 25.01, "point2Lng": 48.1
    },
    {
        "id": 143, "name": "Umluj", "centerLat": 25.021, "centerLng": 37.268, "point1Lat": 25.08, "point1Lng": 37.33, "point2Lat": 24.96, "point2Lng": 37.2
    },
    {
        "id": 144, "name": "Badr", "centerLat": 23.778, "centerLng": 38.79, "point1Lat": 23.83, "point1Lng": 38.85, "point2Lat": 23.71, "point2Lng": 38.73
    },
    {
        "id": 145, "name": "Dumah Al Jandal", "centerLat": 29.811, "centerLng": 39.868, "point1Lat": 29.87, "point1Lng": 39.93, "point2Lat": 29.75, "point2Lng": 39.8
    },
    {
        "id": 146, "name": "Layla", "centerLat": 22.25, "centerLng": 46.73, "point1Lat": 22.31, "point1Lng": 46.79, "point2Lat": 22.19, "point2Lng": 46.67
    },
    {
        "id": 147, "name": "Al Jumum", "centerLat": 21.61, "centerLng": 39.73, "point1Lat": 21.67, "point1Lng": 39.79, "point2Lat": 21.55, "point2Lng": 39.67
    },
    {
        "id": 148, "name": "Almandaq", "centerLat": 20.147, "centerLng": 41.3, "point1Lat": 20.2, "point1Lng": 41.36, "point2Lat": 20.08, "point2Lng": 41.24
    },
    {
        "id": 149, "name": "Khulais", "centerLat": 22.148, "centerLng": 39.317, "point1Lat": 22.2, "point1Lng": 39.38, "point2Lat": 22.08, "point2Lng": 39.25
    },
    {
        "id": 150, "name": "Khaybar", "centerLat": 25.69, "centerLng": 39.49, "point1Lat": 25.75, "point1Lng": 39.55, "point2Lat": 25.63, "point2Lng": 39.43
    },
    {
        "id": 151, "name": "Samtah", "centerLat": 16.593, "centerLng": 42.94, "point1Lat": 16.65, "point1Lng": 43, "point2Lat": 16.53, "point2Lng": 42.88
    },
    {
        "id": 152, "name": "Rijal Almaa", "centerLat": 18.2, "centerLng": 42.3, "point1Lat": 18.26, "point1Lng": 42.36, "point2Lat": 18.14, "point2Lng": 42.24
    },
    {
        "id": 153, "name": "Ranyah", "centerLat": 21.2869, "centerLng": 42.8464, "point1Lat": 21.34, "point1Lng": 42.9, "point2Lat": 21.22, "point2Lng": 42.78
    },
    {
        "id": 154, "name": "Dhahran Al Janub", "centerLat": 17.72, "centerLng": 43.52, "point1Lat": 17.78, "point1Lng": 43.58, "point2Lat": 17.66, "point2Lng": 43.46
    },
    {
        "id": 155, "name": "Mahd Al Thahab", "centerLat": 23.498, "centerLng": 40.855, "point1Lat": 23.55, "point1Lng": 40.91, "point2Lat": 23.43, "point2Lng": 40.79
    },
    {
        "id": 156, "name": "Farasan Island", "centerLat": 16.705, "centerLng": 42.121, "point1Lat": 16.9, "point1Lng": 42.3, "point2Lat": 16.5, "point2Lng": 41.9
    },
    {
        "id": 157, "name": "Al-Badie Al-Shamali", "centerLat": 22.8028, "centerLng": 45.4181, "point1Lat": 22.82, "point1Lng": 45.44, "point2Lat": 22.78, "point2Lng": 45.39
    },
    {
        "id": 158, "name": "Al-Badie Al-Janobi", "centerLat": 22.7758, "centerLng": 45.4192, "point1Lat": 22.79, "point1Lng": 45.44, "point2Lat": 22.75, "point2Lng": 45.39
    },
    {
        "id": 159, "name": "Al Haddar", "centerLat": 22.067, "centerLng": 46.25, "point1Lat": 22.12, "point1Lng": 46.31, "point2Lat": 22, "point2Lng": 46.19
    },
    {
        "id": 160, "name": "Al Artawiyah", "centerLat": 26.54, "centerLng": 45.33, "point1Lat": 26.6, "point1Lng": 45.39, "point2Lat": 26.48, "point2Lng": 45.27
    },
    {
        "id": 161, "name": "Al Haeer", "centerLat": 24.39, "centerLng": 46.85, "point1Lat": 24.45, "point1Lng": 46.91, "point2Lat": 24.33, "point2Lng": 46.79
    },
    {
        "id": 162, "name": "Al Hariq", "centerLat": 23.63, "centerLng": 46.54, "point1Lat": 23.69, "point1Lng": 46.6, "point2Lat": 23.57, "point2Lng": 46.48
    },
    {
        "id": 163, "name": "Al Hayathem", "centerLat": 24.1167, "centerLng": 47.1667, "point1Lat": 24.14, "point1Lng": 47.19, "point2Lat": 24.09, "point2Lng": 47.14
    },
    {
        "id": 164, "name": "Rumah", "centerLat": 25.56, "centerLng": 47.15, "point1Lat": 25.62, "point1Lng": 47.21, "point2Lat": 25.5, "point2Lng": 47.09
    },
    {
        "id": 165, "name": "Sajir", "centerLat": 25.13, "centerLng": 44.57, "point1Lat": 25.19, "point1Lng": 44.63, "point2Lat": 25.07, "point2Lng": 44.51
    },
    {
        "id": 166, "name": "Al Aqiq", "centerLat": 20.25, "centerLng": 41.65, "point1Lat": 20.31, "point1Lng": 41.71, "point2Lat": 20.19, "point2Lng": 41.59
    },
    {
        "id": 167, "name": "Qilwah", "centerLat": 19.74, "centerLng": 41.23, "point1Lat": 19.8, "point1Lng": 41.29, "point2Lat": 19.68, "point2Lng": 41.17
    },
    {
        "id": 168, "name": "Suwayr", "centerLat": 29.74, "centerLng": 40.52, "point1Lat": 29.8, "point1Lng": 40.58, "point2Lat": 29.68, "point2Lng": 40.46
    },
    {
        "id": 169, "name": "Tubarjal", "centerLat": 30.5, "centerLng": 38.22, "point1Lat": 30.56, "point1Lng": 38.28, "point2Lat": 30.44, "point2Lng": 38.16
    },
    {
        "id": 170, "name": "Al Uwayqilah", "centerLat": 30.03, "centerLng": 42.17, "point1Lat": 30.09, "point1Lng": 42.23, "point2Lat": 29.97, "point2Lng": 42.11
    },
    {
        "id": 171, "name": "Al Khabra", "centerLat": 26.046, "centerLng": 43.597, "point1Lat": 26.1, "point1Lng": 43.66, "point2Lat": 25.98, "point2Lng": 43.53
    },
    {
        "id": 172, "name": "Al Thamad", "centerLat": 25.99, "centerLng": 39.5, "point1Lat": 26.05, "point1Lng": 39.56, "point2Lat": 25.93, "point2Lng": 39.44
    },
    {
        "id": 173, "name": "Al Henakiyah", "centerLat": 24.87, "centerLng": 40.54, "point1Lat": 24.93, "point1Lng": 40.6, "point2Lat": 24.81, "point2Lng": 40.48
    },
    {
        "id": 174, "name": "Al Ais", "centerLat": 25.53, "centerLng": 38.07, "point1Lat": 25.59, "point1Lng": 38.13, "point2Lat": 25.47, "point2Lng": 38.01
    },
    {
        "id": 175, "name": "Al Mahfar", "centerLat": 26.316667, "centerLng": 41.316667, "point1Lat": 26.34, "point1Lng": 41.34, "point2Lat": 26.29, "point2Lng": 41.29
    },
    {
        "id": 176, "name": "Al Batha", "centerLat": 24.065, "centerLng": 51.52, "point1Lat": 24.12, "point1Lng": 51.58, "point2Lat": 24, "point2Lng": 51.46
    },
    {
        "id": 177, "name": "Al Wajh", "centerLat": 26.23, "centerLng": 36.45, "point1Lat": 26.29, "point1Lng": 36.51, "point2Lat": 26.17, "point2Lng": 36.39
    },
    {
        "id": 178, "name": "Tayma", "centerLat": 27.629, "centerLng": 38.544, "point1Lat": 27.68, "point1Lng": 38.6, "point2Lat": 27.56, "point2Lng": 38.48
    },
    {
        "id": 179, "name": "Haql", "centerLat": 29.3, "centerLng": 34.95, "point1Lat": 29.36, "point1Lng": 35.01, "point2Lat": 29.24, "point2Lng": 34.89
    },
    {
        "id": 180, "name": "Alsilaa", "centerLat": 23.83, "centerLng": 51.78, "point1Lat": 23.89, "point1Lng": 51.84, "point2Lat": 23.77, "point2Lng": 51.72
    },
    {
        "id": 181, "name": "Ahad Al Masarihah", "centerLat": 16.73, "centerLng": 42.85, "point1Lat": 16.79, "point1Lng": 42.91, "point2Lat": 16.67, "point2Lng": 42.79
    },
    {
        "id": 182, "name": "Al Badi & Al Qarafi", "centerLat": 16.7792, "centerLng": 42.9328, "point1Lat": 16.8, "point1Lng": 42.96, "point2Lat": 16.75, "point2Lng": 42.9
    },
    {
        "id": 183, "name": "Al Jaradiyah", "centerLat": 16.673, "centerLng": 42.883, "point1Lat": 16.7, "point1Lng": 42.91, "point2Lat": 16.64, "point2Lng": 42.85
    },
    {
        "id": 184, "name": "Al Husayni", "centerLat": 16.9419, "centerLng": 42.7153, "point1Lat": 16.97, "point1Lng": 42.74, "point2Lat": 16.91, "point2Lng": 42.68
    },
    {
        "id": 185, "name": "Addayer", "centerLat": 17.33, "centerLng": 43.13, "point1Lat": 17.39, "point1Lng": 43.19, "point2Lat": 17.27, "point2Lng": 43.07
    },
    {
        "id": 186, "name": "Ad Darb", "centerLat": 17.722, "centerLng": 42.257, "point1Lat": 17.78, "point1Lng": 42.32, "point2Lat": 17.66, "point2Lng": 42.19
    },
    {
        "id": 187, "name": "Alshuqayri", "centerLat": 17.26, "centerLng": 42.54, "point1Lat": 17.32, "point1Lng": 42.6, "point2Lat": 17.2, "point2Lng": 42.48
    },
    {
        "id": 188, "name": "Al Tuwal", "centerLat": 16.59, "centerLng": 43.15, "point1Lat": 16.65, "point1Lng": 43.21, "point2Lat": 16.53, "point2Lng": 43.09
    },
    {
        "id": 189, "name": "Al Madaya", "centerLat": 16.72, "centerLng": 42.48, "point1Lat": 16.78, "point1Lng": 42.54, "point2Lat": 16.66, "point2Lng": 42.42
    },
    {
        "id": 190, "name": "Al-Matan", "centerLat": 16.71, "centerLng": 42.66, "point1Lat": 16.77, "point1Lng": 42.72, "point2Lat": 16.65, "point2Lng": 42.6
    },
    {
        "id": 191, "name": "Baish", "centerLat": 17.38, "centerLng": 42.53, "point1Lat": 17.44, "point1Lng": 42.59, "point2Lat": 17.32, "point2Lng": 42.47
    },
    {
        "id": 192, "name": "Damad", "centerLat": 17.07, "centerLng": 42.87, "point1Lat": 17.13, "point1Lng": 42.93, "point2Lat": 17.01, "point2Lng": 42.81
    },
    {
        "id": 193, "name": "Mizhirah", "centerLat": 16.8, "centerLng": 42.69, "point1Lat": 16.86, "point1Lng": 42.75, "point2Lat": 16.74, "point2Lng": 42.63
    },
    {
        "id": 194, "name": "Masliyah", "centerLat": 17.2, "centerLng": 42.66, "point1Lat": 17.26, "point1Lng": 42.72, "point2Lat": 17.14, "point2Lng": 42.6
    },
    {
        "id": 195, "name": "Al Hait", "centerLat": 25.88, "centerLng": 40.58, "point1Lat": 25.94, "point1Lng": 40.64, "point2Lat": 25.82, "point2Lng": 40.52
    },
    {
        "id": 196, "name": "Ash Shinan", "centerLat": 27.2, "centerLng": 41.98, "point1Lat": 27.26, "point1Lng": 42.04, "point2Lat": 27.14, "point2Lng": 41.92
    },
    {
        "id": 197, "name": "Al-Iṯnayn", "centerLat": 19.333333, "centerLng": 41.483333, "point1Lat": 19.36, "point1Lng": 41.51, "point2Lat": 19.3, "point2Lng": 41.45
    },
    {
        "id": 198, "name": "Almajaridah", "centerLat": 19.12, "centerLng": 41.91, "point1Lat": 19.18, "point1Lng": 41.97, "point2Lat": 19.06, "point2Lng": 41.85
    },
    {
        "id": 199, "name": "Tathleeth", "centerLat": 19.55, "centerLng": 43.5, "point1Lat": 19.61, "point1Lng": 43.56, "point2Lat": 19.49, "point2Lng": 43.44
    },
    {
        "id": 200, "name": "Tanomah", "centerLat": 18.995, "centerLng": 42.176, "point1Lat": 19.05, "point1Lng": 42.24, "point2Lat": 18.93, "point2Lng": 42.11
    },
    {
        "id": 201, "name": "Tereeb", "centerLat": 18.42, "centerLng": 42.66, "point1Lat": 18.48, "point1Lng": 42.72, "point2Lat": 18.36, "point2Lng": 42.6
    },
    {
        "id": 202, "name": "Muhayil", "centerLat": 18.547, "centerLng": 42.046, "point1Lat": 18.6, "point1Lng": 42.1, "point2Lat": 18.48, "point2Lng": 41.98
    },
    {
        "id": 203, "name": "AlQouz", "centerLat": 19.78, "centerLng": 41.28, "point1Lat": 19.84, "point1Lng": 41.34, "point2Lat": 19.72, "point2Lng": 41.22
    },
    {
        "id": 204, "name": "Ashayrah", "centerLat": 21.8, "centerLng": 40.76, "point1Lat": 21.86, "point1Lng": 40.82, "point2Lat": 21.74, "point2Lng": 40.7
    },
    {
        "id": 205, "name": "Mastorah", "centerLat": 23.08, "centerLng": 38.83, "point1Lat": 23.14, "point1Lng": 38.89, "point2Lat": 23.02, "point2Lng": 38.77
    },
    {
        "id": 206, "name": "Al Mishaliah", "centerLat": 17.65, "centerLng": 44.25, "point1Lat": 17.71, "point1Lng": 44.31, "point2Lat": 17.59, "point2Lng": 44.19
    },
    {
        "id": 207, "name": "Hubuna", "centerLat": 17.89, "centerLng": 44.6, "point1Lat": 17.95, "point1Lng": 44.66, "point2Lat": 17.83, "point2Lng": 44.54
    },
    {
        "id": 208, "name": "Nairyah", "centerLat": 27.49, "centerLng": 48.49, "point1Lat": 27.55, "point1Lng": 48.55, "point2Lat": 27.43, "point2Lng": 48.43
    },
    {
        "id": 209, "name": "Bahrah", "centerLat": 21.36, "centerLng": 39.4, "point1Lat": 21.42, "point1Lng": 39.46, "point2Lat": 21.3, "point2Lng": 39.34
    },
    {
        "id": 210, "name": "Wadi Ibn Hashbal", "centerLat": 18.508, "centerLng": 42.923, "point1Lat": 18.56, "point1Lng": 42.98, "point2Lat": 18.44, "point2Lng": 42.86
    },
    {
        "id": 211, "name": "Khaiber Al-Janoub", "centerLat": 19.33, "centerLng": 42.23, "point1Lat": 19.39, "point1Lng": 42.29, "point2Lat": 19.27, "point2Lng": 42.17
    },
    {
        "id": 212, "name": "Al Madha", "centerLat": 17.82, "centerLng": 43.34, "point1Lat": 17.88, "point1Lng": 43.4, "point2Lat": 17.76, "point2Lng": 43.28
    },
    {
        "id": 213, "name": "Sabt Alalayah", "centerLat": 19.55, "centerLng": 41.9, "point1Lat": 19.61, "point1Lng": 41.96, "point2Lat": 19.49, "point2Lng": 41.84
    },
    {
        "id": 214, "name": "Duhknah", "centerLat": 25.13, "centerLng": 42.66, "point1Lat": 25.19, "point1Lng": 42.72, "point2Lat": 25.07, "point2Lng": 42.6
    },
    {
        "id": 215, "name": "Shuwaq", "centerLat": 27.67, "centerLng": 36.1, "point1Lat": 27.73, "point1Lng": 36.16, "point2Lat": 27.61, "point2Lng": 36.04
    },
    {
        "id": 216, "name": "Madain Saleh", "centerLat": 26.81, "centerLng": 37.95, "point1Lat": 26.87, "point1Lng": 38.01, "point2Lat": 26.75, "point2Lng": 37.89
    },
    {
        "id": 217, "name": "Fadhla", "centerLat": 25.4333, "centerLng": 49.3333, "point1Lat": 25.46, "point1Lng": 49.36, "point2Lat": 25.4, "point2Lng": 49.3
    },
    {
        "id": 218, "name": "Hazem Aljalamid", "centerLat": 31.06, "centerLng": 39.88, "point1Lat": 31.12, "point1Lng": 39.94, "point2Lat": 31, "point2Lng": 39.82
    },
    {
        "id": 219, "name": "Meegowa", "centerLat": 30.2, "centerLng": 39.9, "point1Lat": 30.26, "point1Lng": 39.96, "point2Lat": 30.14, "point2Lng": 39.84
    },
    {
        "id": 220, "name": "Ar Rayis", "centerLat": 23.63, "centerLng": 38.6, "point1Lat": 23.69, "point1Lng": 38.66, "point2Lat": 23.57, "point2Lng": 38.54
    },
    {
        "id": 221, "name": "Abyar 'Ali", "centerLat": 24.37, "centerLng": 39.54, "point1Lat": 24.43, "point1Lng": 39.6, "point2Lat": 24.31, "point2Lng": 39.48
    },
    {
        "id": 222, "name": "New Muwayh", "centerLat": 22.43, "centerLng": 41.76, "point1Lat": 22.49, "point1Lng": 41.82, "point2Lat": 22.37, "point2Lng": 41.7
    },
    {
        "id": 223, "name": "Yadamah", "centerLat": 18.9, "centerLng": 45, "point1Lat": 18.96, "point1Lng": 45.06, "point2Lat": 18.84, "point2Lng": 44.94
    },
    {
        "id": 224, "name": "Al Wadiah", "centerLat": 17.27, "centerLng": 47.78, "point1Lat": 17.33, "point1Lng": 47.84, "point2Lat": 17.21, "point2Lng": 47.72
    },
    {
        "id": 225, "name": "Umm Al Melh", "centerLat": 18.4, "centerLng": 46.7, "point1Lat": 18.46, "point1Lng": 46.76, "point2Lat": 18.34, "point2Lng": 46.64
    },
    {
        "id": 226, "name": "Al Kharkhir", "centerLat": 19, "centerLng": 51, "point1Lat": 19.06, "point1Lng": 51.06, "point2Lat": 18.94, "point2Lng": 50.94
    },
    {
        "id": 227, "name": "Thabhloten", "centerLat": 20.25, "centerLng": 50.8, "point1Lat": 20.31, "point1Lng": 50.86, "point2Lat": 20.19, "point2Lng": 50.74
    },
    {
        "id": 228, "name": "Ash Shalfa", "centerLat": 28.53, "centerLng": 42.4, "point1Lat": 28.59, "point1Lng": 42.46, "point2Lat": 28.47, "point2Lng": 42.34
    },
    {
        "id": 229, "name": "Ar Rayn", "centerLat": 23.51, "centerLng": 45.47, "point1Lat": 23.57, "point1Lng": 45.53, "point2Lat": 23.45, "point2Lng": 45.41
    },
    {
        "id": 230, "name": "Ar Ruwaidhah", "centerLat": 24.16, "centerLng": 44.75, "point1Lat": 24.22, "point1Lng": 44.81, "point2Lat": 24.1, "point2Lng": 44.69
    },
    {
        "id": 231, "name": "Uglat Asugour", "centerLat": 25.75, "centerLng": 42.25, "point1Lat": 25.81, "point1Lng": 42.31, "point2Lat": 25.69, "point2Lng": 42.19
    },
    {
        "id": 232, "name": "Al Qaisumah", "centerLat": 28.31, "centerLng": 46.129, "point1Lat": 28.37, "point1Lng": 46.19, "point2Lat": 28.25, "point2Lng": 46.06
    },
    {
        "id": 233, "name": "Kouba", "centerLat": 26.83, "centerLng": 43.5, "point1Lat": 26.89, "point1Lng": 43.56, "point2Lat": 26.77, "point2Lng": 43.44
    },
    {
        "id": 234, "name": "Linah", "centerLat": 28.8, "centerLng": 44, "point1Lat": 28.86, "point1Lng": 44.06, "point2Lat": 28.74, "point2Lng": 43.94
    },
    {
        "id": 235, "name": "Baqaa", "centerLat": 27.75, "centerLng": 42.45, "point1Lat": 27.81, "point1Lng": 42.51, "point2Lat": 27.69, "point2Lng": 42.39
    },
    {
        "id": 236, "name": "Al Qaid", "centerLat": 27.81, "centerLng": 41.69, "point1Lat": 27.87, "point1Lng": 41.75, "point2Lat": 27.75, "point2Lng": 41.63
    },
    {
        "id": 237, "name": "Al Ghazalah", "centerLat": 26.8, "centerLng": 41.4, "point1Lat": 26.86, "point1Lng": 41.46, "point2Lat": 26.74, "point2Lng": 41.34
    },
    {
        "id": 238, "name": "Asbtar", "centerLat": 26.4, "centerLng": 41.7, "point1Lat": 26.46, "point1Lng": 41.76, "point2Lat": 26.34, "point2Lng": 41.64
    },
    {
        "id": 239, "name": "As Shamli", "centerLat": 26.75, "centerLng": 40.1, "point1Lat": 26.81, "point1Lng": 40.16, "point2Lat": 26.69, "point2Lng": 40.04
    },
    {
        "id": 240, "name": "Al Hulayfah As Sufla", "centerLat": 25.5, "centerLng": 40.8, "point1Lat": 25.56, "point1Lng": 40.86, "point2Lat": 25.44, "point2Lng": 40.74
    },
    {
        "id": 241, "name": "`Ushash", "centerLat": 26.2, "centerLng": 39.5, "point1Lat": 26.26, "point1Lng": 39.56, "point2Lat": 26.14, "point2Lng": 39.44
    },
    {
        "id": 242, "name": "King Abdullah Economic City", "centerLat": 22.383, "centerLng": 39.117, "point1Lat": 22.5, "point1Lng": 39.2, "point2Lat": 22.3, "point2Lng": 39
    },
    {
        "id": 243, "name": "Dhahban", "centerLat": 21.895, "centerLng": 39.12, "point1Lat": 21.95, "point1Lng": 39.18, "point2Lat": 21.83, "point2Lng": 39.06
    },
    {
        "id": 244, "name": "Ayn Qahtan", "centerLat": 18.066667, "centerLng": 42.483333, "point1Lat": 18.09, "point1Lng": 42.51, "point2Lat": 18.04, "point2Lng": 42.45
    },
    {
        "id": 245, "name": "Fayfa", "centerLat": 17.24, "centerLng": 43.08, "point1Lat": 17.3, "point1Lng": 43.14, "point2Lat": 17.18, "point2Lng": 43.02
    },
    {
        "id": 246, "name": "As Sa'diyah", "centerLat": 21.62, "centerLng": 40, "point1Lat": 21.68, "point1Lng": 40.06, "point2Lat": 21.56, "point2Lng": 39.94
    },
    {
        "id": 247, "name": "Al Subaykhah", "centerLat": 25.59, "centerLng": 42.66, "point1Lat": 25.65, "point1Lng": 42.72, "point2Lat": 25.53, "point2Lng": 42.6
    },
    {
        "id": 248, "name": "Al Marameh", "centerLat": 25.516667, "centerLng": 43.15, "point1Lat": 25.54, "point1Lng": 43.18, "point2Lat": 25.49, "point2Lng": 43.12
    },
    {
        "id": 249, "name": "Ras Al Khair", "centerLat": 27.5, "centerLng": 49.2, "point1Lat": 27.56, "point1Lng": 49.26, "point2Lat": 27.44, "point2Lng": 49.14
    },
    {
        "id": 250, "name": "Salwa", "centerLat": 24.84, "centerLng": 50.77, "point1Lat": 24.9, "point1Lng": 50.83, "point2Lat": 24.78, "point2Lng": 50.71
    },
    {
        "id": 251, "name": "Ash Shihyah", "centerLat": 26.5, "centerLng": 43.83, "point1Lat": 26.56, "point1Lng": 43.89, "point2Lat": 26.44, "point2Lng": 43.77
    },
    {
        "id": 252, "name": "Rvaya Aljamsh", "centerLat": 24.75, "centerLng": 43.43, "point1Lat": 24.81, "point1Lng": 43.49, "point2Lat": 24.69, "point2Lng": 43.37
    },
    {
        "id": 253, "name": "Qaryat Al Ulya", "centerLat": 27.6, "centerLng": 47.7, "point1Lat": 27.66, "point1Lng": 47.76, "point2Lat": 27.54, "point2Lng": 47.64
    },
    {
        "id": 254, "name": "Audat Sudair", "centerLat": 25.59, "centerLng": 45.71, "point1Lat": 25.65, "point1Lng": 45.77, "point2Lat": 25.53, "point2Lng": 45.65
    },
    {
        "id": 255, "name": "Ath Thybiyah", "centerLat": 27.7, "centerLng": 44.9, "point1Lat": 27.76, "point1Lng": 44.96, "point2Lat": 27.64, "point2Lng": 44.84
    },
    {
        "id": 256, "name": "Al Oyun", "centerLat": 25.58, "centerLng": 49.58, "point1Lat": 25.64, "point1Lng": 49.64, "point2Lat": 25.52, "point2Lng": 49.52
    },
    {
        "id": 257, "name": "Al Wozeyh", "centerLat": 25.43, "centerLng": 49.25, "point1Lat": 25.49, "point1Lng": 49.31, "point2Lat": 25.37, "point2Lng": 49.19
    },
    {
        "id": 258, "name": "Juatha", "centerLat": 25.41, "centerLng": 49.66, "point1Lat": 25.47, "point1Lng": 49.72, "point2Lat": 25.35, "point2Lng": 49.6
    },
    {
        "id": 259, "name": "Al Umran", "centerLat": 25.26, "centerLng": 49.58, "point1Lat": 25.32, "point1Lng": 49.64, "point2Lat": 25.2, "point2Lng": 49.52
    },
    {
        "id": 260, "name": "Julayjilah", "centerLat": 25.8, "centerLng": 49.1, "point1Lat": 25.86, "point1Lng": 49.16, "point2Lat": 25.74, "point2Lng": 49.04
    },
    {
        "id": 261, "name": "Al Taraf", "centerLat": 25.3, "centerLng": 49.66, "point1Lat": 25.36, "point1Lng": 49.72, "point2Lat": 25.24, "point2Lng": 49.6
    },
    {
        "id": 262, "name": "Al Jafr", "centerLat": 25.28, "centerLng": 49.72, "point1Lat": 25.34, "point1Lng": 49.78, "point2Lat": 25.22, "point2Lng": 49.66
    },
    {
        "id": 263, "name": "Udhailiyah", "centerLat": 25, "centerLng": 49.33, "point1Lat": 25.06, "point1Lng": 49.39, "point2Lat": 24.94, "point2Lng": 49.27
    },
    {
        "id": 264, "name": "Al Bijadyah", "centerLat": 24.66, "centerLng": 43.7, "point1Lat": 24.72, "point1Lng": 43.76, "point2Lat": 24.6, "point2Lng": 43.64
    },
    {
        "id": 265, "name": "Khaw'a", "centerLat": 30.633333, "centerLng": 39.5, "point1Lat": 30.66, "point1Lng": 39.53, "point2Lat": 30.6, "point2Lng": 39.47
    },
    {
        "id": 266, "name": "Azfaa", "centerLat": 31.05, "centerLng": 38.3, "point1Lat": 31.11, "point1Lng": 38.36, "point2Lat": 30.99, "point2Lng": 38.24
    },
    {
        "id": 267, "name": "Zalom", "centerLat": 30.13, "centerLng": 40, "point1Lat": 30.19, "point1Lng": 40.06, "point2Lat": 30.07, "point2Lng": 39.94
    },
    {
        "id": 268, "name": "Ar Rafi'ah", "centerLat": 27.2, "centerLng": 46.8, "point1Lat": 27.26, "point1Lng": 46.86, "point2Lat": 27.14, "point2Lng": 46.74
    },
    {
        "id": 269, "name": "Hedeb", "centerLat": 26.5, "centerLng": 46.5, "point1Lat": 26.56, "point1Lng": 46.56, "point2Lat": 26.44, "point2Lng": 46.44
    },
    {
        "id": 270, "name": "Al Jesh", "centerLat": 26.5416, "centerLng": 49.9323, "point1Lat": 26.56, "point1Lng": 49.95, "point2Lat": 26.52, "point2Lng": 49.91
    },
    {
        "id": 271, "name": "Al Shuqaiq", "centerLat": 17.7, "centerLng": 42, "point1Lat": 17.76, "point1Lng": 42.06, "point2Lat": 17.64, "point2Lng": 41.94
    },
    {
        "id": 272, "name": "Al Awamiyah", "centerLat": 26.58, "centerLng": 49.96, "point1Lat": 26.64, "point1Lng": 50.02, "point2Lat": 26.52, "point2Lng": 49.9
    },
    {
        "id": 273, "name": "King Khalid Military City", "centerLat": 27.97, "centerLng": 45.53, "point1Lat": 28.05, "point1Lng": 45.6, "point2Lat": 27.9, "point2Lng": 45.45
    },
    {
        "id": 274, "name": "Umm As Sahik", "centerLat": 26.69, "centerLng": 49.8, "point1Lat": 26.75, "point1Lng": 49.86, "point2Lat": 26.63, "point2Lng": 49.74
    },
    {
        "id": 275, "name": "Al Ahmar", "centerLat": 23.016667, "centerLng": 45.7, "point1Lat": 23.04, "point1Lng": 45.73, "point2Lat": 22.99, "point2Lng": 45.67
    },
    {
        "id": 276, "name": "Al Aridhah", "centerLat": 17.05, "centerLng": 43.08, "point1Lat": 17.11, "point1Lng": 43.14, "point2Lat": 16.99, "point2Lng": 43.02
    },
    {
        "id": 277, "name": "Al Hadithah", "centerLat": 31.55, "centerLng": 37.15, "point1Lat": 31.61, "point1Lng": 37.21, "point2Lat": 31.49, "point2Lng": 37.09
    },
    {
        "id": 278, "name": "Al Mubarakah", "centerLat": 20.35, "centerLng": 40.75, "point1Lat": 20.41, "point1Lng": 40.81, "point2Lat": 20.29, "point2Lng": 40.69
    },
    {
        "id": 279, "name": "Al Qasab", "centerLat": 25.352, "centerLng": 45.419, "point1Lat": 25.37, "point1Lng": 45.44, "point2Lat": 25.33, "point2Lng": 45.39
    },
    {
        "id": 280, "name": "Ayn Ibn Fuhayd", "centerLat": 26.683333, "centerLng": 43.666667, "point1Lat": 26.71, "point1Lng": 43.69, "point2Lat": 26.65, "point2Lng": 43.63
    },
    {
        "id": 281, "name": "Ghtai", "centerLat": 26.01, "centerLng": 44.97, "point1Lat": 26.07, "point1Lng": 45.03, "point2Lat": 25.95, "point2Lng": 44.91
    },
    {
        "id": 282, "name": "Jazan Economic City", "centerLat": 17.29, "centerLng": 42.48, "point1Lat": 17.4, "point1Lng": 42.55, "point2Lat": 17.2, "point2Lng": 42.4
    },
    {
        "id": 283, "name": "Mahalah", "centerLat": 17.15, "centerLng": 42.9, "point1Lat": 17.21, "point1Lng": 42.96, "point2Lat": 17.09, "point2Lng": 42.84
    },
    {
        "id": 284, "name": "Um Saad", "centerLat": 28.53, "centerLng": 47.4, "point1Lat": 28.59, "point1Lng": 47.46, "point2Lat": 28.47, "point2Lng": 47.34
    },
    {
        "id": 285, "name": "asfan", "centerLat": 22, "centerLng": 39.3, "point1Lat": 22.06, "point1Lng": 39.36, "point2Lat": 21.94, "point2Lng": 39.24
    },
    {
        "id": 286, "name": "An Nabiyah", "centerLat": 26.6, "centerLng": 49.9, "point1Lat": 26.66, "point1Lng": 49.96, "point2Lat": 26.54, "point2Lng": 49.84
    },
    {
        "id": 287, "name": "aljamieia", "centerLat": 21.6, "centerLng": 39.15, "point1Lat": 21.66, "point1Lng": 39.21, "point2Lat": 21.54, "point2Lng": 39.09
    },
    {
        "id": 288, "name": "alawjam", "centerLat": 26.57, "centerLng": 49.87, "point1Lat": 26.63, "point1Lng": 49.93, "point2Lat": 26.51, "point2Lng": 49.81
    },
    {
        "id": 289, "name": "ain dar", "centerLat": 25.9922, "centerLng": 49.378, "point1Lat": 26.01, "point1Lng": 49.4, "point2Lat": 25.97, "point2Lng": 49.35
    },
    {
        "id": 290, "name": "aldighaimi", "centerLat": 24.73333, "centerLng": 39.11667, "point1Lat": 24.75, "point1Lng": 39.14, "point2Lat": 24.71, "point2Lng": 39.09
    },
    {
        "id": 291, "name": "alshaffa", "centerLat": 21.15, "centerLng": 40.35, "point1Lat": 21.21, "point1Lng": 40.41, "point2Lat": 21.09, "point2Lng": 40.29
    },
    {
        "id": 292, "name": "alsayl alkabir", "centerLat": 21.6, "centerLng": 40.1, "point1Lat": 21.66, "point1Lng": 40.16, "point2Lat": 21.54, "point2Lng": 40.04
    },
    {
        "id": 293, "name": "alsayl alsaghir", "centerLat": 21.55, "centerLng": 40.43, "point1Lat": 21.61, "point1Lng": 40.49, "point2Lat": 21.49, "point2Lng": 40.37
    },
    {
        "id": 294, "name": "As Sarrar", "centerLat": 26.9, "centerLng": 48.6, "point1Lat": 26.96, "point1Lng": 48.66, "point2Lat": 26.84, "point2Lng": 48.54
    },
    {
        "id": 295, "name": "Adham", "centerLat": 19.5, "centerLng": 41.6, "point1Lat": 19.56, "point1Lng": 41.66, "point2Lat": 19.44, "point2Lng": 41.54
    },
    {
        "id": 296, "name": "Al Edabi", "centerLat": 17.2, "centerLng": 42.9, "point1Lat": 17.26, "point1Lng": 42.96, "point2Lat": 17.14, "point2Lng": 42.84
    },
    {
        "id": 297, "name": "Namerah", "centerLat": 19.26, "centerLng": 41.7, "point1Lat": 19.32, "point1Lng": 41.76, "point2Lat": 19.2, "point2Lng": 41.64
    },
    {
        "id": 298, "name": "Al Quwarah", "centerLat": 26.8, "centerLng": 43.6, "point1Lat": 26.86, "point1Lng": 43.66, "point2Lat": 26.74, "point2Lng": 43.54
    },
    {
        "id": 299, "name": "Dariyah", "centerLat": 25.5, "centerLng": 43.3, "point1Lat": 25.56, "point1Lng": 43.36, "point2Lat": 25.44, "point2Lng": 43.24
    },
    {
        "id": 300, "name": "Bir Ibn Hirmas", "centerLat": 28.7, "centerLng": 36.3, "point1Lat": 28.76, "point1Lng": 36.36, "point2Lat": 28.64, "point2Lng": 36.24
    },
    {
        "id": 301, "name": "Tanda", "centerLat": 18.25, "centerLng": 42.83, "point1Lat": 18.31, "point1Lng": 42.89, "point2Lat": 18.19, "point2Lng": 42.77
    },
    {
        "id": 302, "name": "Abyar Al Mashi", "centerLat": 24.31, "centerLng": 39.42, "point1Lat": 24.37, "point1Lng": 39.48, "point2Lat": 24.25, "point2Lng": 39.36
    },
    {
        "id": 303, "name": "ASYAH", "centerLat": 26.6853, "centerLng": 43.6828, "point1Lat": 26.74, "point1Lng": 43.74, "point2Lat": 26.62, "point2Lng": 43.62
    },
    {
        "id": 304, "name": "Al Dulaymiyah", "centerLat": 25.75, "centerLng": 43.25, "point1Lat": 25.81, "point1Lng": 43.31, "point2Lat": 25.69, "point2Lng": 43.19
    },
    {
        "id": 305, "name": "As Samuriyah", "centerLat": 25.9, "centerLng": 43.3, "point1Lat": 25.96, "point1Lng": 43.36, "point2Lat": 25.84, "point2Lng": 43.24
    },
    {
        "id": 306, "name": "DULAY RASHID", "centerLat": 25.2, "centerLng": 42.4, "point1Lat": 25.26, "point1Lng": 42.46, "point2Lat": 25.14, "point2Lng": 42.34
    },
    {
        "id": 307, "name": "Al Khushaybi", "centerLat": 25.3, "centerLng": 43.1, "point1Lat": 25.36, "point1Lng": 43.16, "point2Lat": 25.24, "point2Lng": 43.04
    },
    {
        "id": 308, "name": "Al Juaima'h", "centerLat": 26.7, "centerLng": 50.05, "point1Lat": 26.76, "point1Lng": 50.11, "point2Lat": 26.64, "point2Lng": 49.99
    },
    {
        "id": 309, "name": "Mubhel", "centerLat": 25.6, "centerLng": 42.8, "point1Lat": 25.66, "point1Lng": 42.86, "point2Lat": 25.54, "point2Lng": 42.74
    },
    {
        "id": 310, "name": "ALKHASIYBAH", "centerLat": 26.35, "centerLng": 44.25, "point1Lat": 26.41, "point1Lng": 44.31, "point2Lat": 26.29, "point2Lng": 44.19
    },
    {
        "id": 311, "name": "AL BASR", "centerLat": 26.3, "centerLng": 43.8, "point1Lat": 26.36, "point1Lng": 43.86, "point2Lat": 26.24, "point2Lng": 43.74
    },
    {
        "id": 312, "name": "AL MALIDA", "centerLat": 26.4, "centerLng": 43.9, "point1Lat": 26.46, "point1Lng": 43.96, "point2Lat": 26.34, "point2Lng": 43.84
    },
    {
        "id": 313, "name": "QADEIMAH", "centerLat": 22.3, "centerLng": 39.2, "point1Lat": 22.36, "point1Lng": 39.26, "point2Lat": 22.24, "point2Lng": 39.14
    },
    {
        "id": 314, "name": "ALSAMAD", "centerLat": 26.6, "centerLng": 42, "point1Lat": 26.66, "point1Lng": 42.06, "point2Lat": 26.54, "point2Lng": 41.94
    },
    {
        "id": 315, "name": "Al Mahabbah", "centerLat": 22.1, "centerLng": 44, "point1Lat": 22.16, "point1Lng": 44.06, "point2Lat": 22.04, "point2Lng": 43.94
    },
    {
        "id": 316, "name": "Ash Shuara", "centerLat": 24.9, "centerLng": 44.3, "point1Lat": 24.96, "point1Lng": 44.36, "point2Lat": 24.84, "point2Lng": 44.24
    },
    {
        "id": 317, "name": "Ushaiqer", "centerLat": 25.3, "centerLng": 45.3, "point1Lat": 25.36, "point1Lng": 45.36, "point2Lat": 25.24, "point2Lng": 45.24
    },
    {
        "id": 318, "name": "Al Hufayr", "centerLat": 27.6, "centerLng": 41.2, "point1Lat": 27.66, "point1Lng": 41.26, "point2Lat": 27.54, "point2Lng": 41.14
    },
    {
        "id": 319, "name": "Mawqaq", "centerLat": 27.3, "centerLng": 41.2, "point1Lat": 27.36, "point1Lng": 41.26, "point2Lat": 27.24, "point2Lng": 41.14
    },
    {
        "id": 320, "name": "Jubbah", "centerLat": 28.1, "centerLng": 41, "point1Lat": 28.16, "point1Lng": 41.06, "point2Lat": 28.04, "point2Lng": 40.94
    },
    {
        "id": 321, "name": "Al Khitah", "centerLat": 27.5, "centerLng": 41.5, "point1Lat": 27.56, "point1Lng": 41.56, "point2Lat": 27.44, "point2Lng": 41.44
    },
    {
        "id": 322, "name": "Hajrah", "centerLat": 19.4, "centerLng": 42.1, "point1Lat": 19.46, "point1Lng": 42.16, "point2Lat": 19.34, "point2Lng": 42.04
    },
    {
        "id": 323, "name": "Al Aflaj", "centerLat": 22.3, "centerLng": 46.7, "point1Lat": 22.4, "point1Lng": 46.8, "point2Lat": 22.2, "point2Lng": 46.6
    },
    {
        "id": 324, "name": "Al Atawilah", "centerLat": 20, "centerLng": 41.4, "point1Lat": 20.06, "point1Lng": 41.46, "point2Lat": 19.94, "point2Lng": 41.34
    },
    {
        "id": 325, "name": "Al Mawain", "centerLat": 18.3, "centerLng": 42.6, "point1Lat": 18.36, "point1Lng": 42.66, "point2Lat": 18.24, "point2Lng": 42.54
    },
    {
        "id": 326, "name": "Al-Abwa", "centerLat": 23.1, "centerLng": 39, "point1Lat": 23.16, "point1Lng": 39.06, "point2Lat": 23.04, "point2Lng": 38.94
    },
    {
        "id": 327, "name": "Al Khutt", "centerLat": 17.6, "centerLng": 43.6, "point1Lat": 17.66, "point1Lng": 43.66, "point2Lat": 17.54, "point2Lng": 43.54
    },
    {
        "id": 328, "name": "Al Omran", "centerLat": 25.26, "centerLng": 49.58, "point1Lat": 25.32, "point1Lng": 49.64, "point2Lat": 25.2, "point2Lng": 49.52
    },
    {
        "id": 329, "name": "Az Zaimah", "centerLat": 21.6, "centerLng": 40, "point1Lat": 21.66, "point1Lng": 40.06, "point2Lat": 21.54, "point2Lng": 39.94
    },
    {
        "id": 330, "name": "Buq A", "centerLat": 27.75, "centerLng": 42.45, "point1Lat": 27.81, "point1Lng": 42.51, "point2Lat": 27.69, "point2Lng": 42.39
    },
    {
        "id": 331, "name": "Gamika", "centerLat": 21.366667, "centerLng": 41.533333, "point1Lat": 21.39, "point1Lng": 41.56, "point2Lat": 21.34, "point2Lng": 41.5
    },
    {
        "id": 332, "name": "Gatgat", "centerLat": 24.2, "centerLng": 46.4, "point1Lat": 24.26, "point1Lng": 46.46, "point2Lat": 24.14, "point2Lng": 46.34
    },
    {
        "id": 333, "name": "Gerrha", "centerLat": 26.5, "centerLng": 50.1, "point1Lat": 26.56, "point1Lng": 50.16, "point2Lat": 26.44, "point2Lng": 50.04
    },
    {
        "id": 334, "name": "Habala", "centerLat": 18, "centerLng": 42.9, "point1Lat": 18.06, "point1Lng": 42.96, "point2Lat": 17.94, "point2Lng": 42.84
    },
    {
        "id": 335, "name": "Harmah", "centerLat": 25.9, "centerLng": 45.3, "point1Lat": 25.96, "point1Lng": 45.36, "point2Lat": 25.84, "point2Lng": 45.24
    },
    {
        "id": 336, "name": "Jabal Umm al Ru'us", "centerLat": 27.5, "centerLng": 40.5, "point1Lat": 27.56, "point1Lng": 40.56, "point2Lat": 27.44, "point2Lng": 40.44
    },
    {
        "id": 337, "name": "Al Jowf", "centerLat": 29.5, "centerLng": 39.5, "point1Lat": 30.5, "point1Lng": 40.5, "point2Lat": 28.5, "point2Lng": 38.5
    },
    {
        "id": 338, "name": "Knowledge Economic City", "centerLat": 24.45, "centerLng": 39.68, "point1Lat": 24.5, "point1Lng": 39.75, "point2Lat": 24.4, "point2Lng": 39.6
    },
    {
        "id": 339, "name": "Lihyan", "centerLat": 26.6, "centerLng": 37.9, "point1Lat": 26.66, "point1Lng": 37.96, "point2Lat": 26.54, "point2Lng": 37.84
    },
    {
        "id": 340, "name": "Qalat Bishah", "centerLat": 20, "centerLng": 42.6, "point1Lat": 20.06, "point1Lng": 42.66, "point2Lat": 19.94, "point2Lng": 42.54
    },
    {
        "id": 341, "name": "Al Rumailah", "centerLat": 25.4, "centerLng": 49.6, "point1Lat": 25.46, "point1Lng": 49.66, "point2Lat": 25.34, "point2Lng": 49.54
    },
    {
        "id": 342, "name": "Shaybah", "centerLat": 22.5, "centerLng": 53.9, "point1Lat": 22.56, "point1Lng": 53.96, "point2Lat": 22.44, "point2Lng": 53.84
    },
    {
        "id": 343, "name": "Al Uqayr", "centerLat": 25.6, "centerLng": 50.2, "point1Lat": 25.66, "point1Lng": 50.26, "point2Lat": 25.54, "point2Lng": 50.14
    },
    {
        "id": 344, "name": "Al Farshah", "centerLat": 18, "centerLng": 43.1, "point1Lat": 18.06, "point1Lng": 43.16, "point2Lat": 17.94, "point2Lng": 43.04
    },
    {
        "id": 345, "name": "Billasmar", "centerLat": 18.8, "centerLng": 42.3, "point1Lat": 18.86, "point1Lng": 42.36, "point2Lat": 18.74, "point2Lng": 42.24
    },
    {
        "id": 346, "name": "UTHAL", "centerLat": 22.2, "centerLng": 39.2, "point1Lat": 22.26, "point1Lng": 39.26, "point2Lat": 22.14, "point2Lng": 39.14
    },
    {
        "id": 347, "name": "tharmda", "centerLat": 25.263, "centerLng": 45.541, "point1Lat": 25.32, "point1Lng": 45.6, "point2Lat": 25.2, "point2Lng": 45.48
    },
    {
        "id": 348, "name": "Ahad Al Masarhah", "centerLat": 16.73, "centerLng": 42.85, "point1Lat": 16.79, "point1Lng": 42.91, "point2Lat": 16.67, "point2Lng": 42.79
    },
    {
        "id": 349, "name": "Al Uraija", "centerLat": 24.6, "centerLng": 46.6, "point1Lat": 24.66, "point1Lng": 46.66, "point2Lat": 24.54, "point2Lng": 46.54
    },
    {
        "id": 350, "name": "Atawlah", "centerLat": 20, "centerLng": 41.4, "point1Lat": 20.06, "point1Lng": 41.46, "point2Lat": 19.94, "point2Lng": 41.34
    },
    {
        "id": 351, "name": "Bad", "centerLat": 27.2, "centerLng": 36.6, "point1Lat": 27.26, "point1Lng": 36.66, "point2Lat": 27.14, "point2Lng": 36.54
    },
    {
        "id": 352, "name": "Bahrain Causeway", "centerLat": 26.18, "centerLng": 50.4, "point1Lat": 26.24, "point1Lng": 50.46, "point2Lat": 26.12, "point2Lng": 50.34
    },
    {
        "id": 353, "name": "Dhalim", "centerLat": 22.7, "centerLng": 42.2, "point1Lat": 22.76, "point1Lng": 42.26, "point2Lat": 22.64, "point2Lng": 42.14
    },
    {
        "id": 354, "name": "Dhuba", "centerLat": 27.351, "centerLng": 35.692, "point1Lat": 27.41, "point1Lng": 35.75, "point2Lat": 27.29, "point2Lng": 35.63
    },
    {
        "id": 355, "name": "Duwadimi", "centerLat": 24.5074, "centerLng": 44.3977, "point1Lat": 24.57, "point1Lng": 44.46, "point2Lat": 24.44, "point2Lng": 44.33
    },
    {
        "id": 356, "name": "Haditha", "centerLat": 31.55, "centerLng": 37.15, "point1Lat": 31.61, "point1Lng": 37.21, "point2Lat": 31.49, "point2Lng": 37.09
    },
    {
        "id": 357, "name": "Halat Ammar", "centerLat": 29.2, "centerLng": 36.1, "point1Lat": 29.26, "point1Lng": 36.16, "point2Lat": 29.14, "point2Lng": 36.04
    },
    {
        "id": 358, "name": "Halit Ammar", "centerLat": 29.2, "centerLng": 36.1, "point1Lat": 29.26, "point1Lng": 36.16, "point2Lat": 29.14, "point2Lng": 36.04
    },
    {
        "id": 359, "name": "Harad", "centerLat": 24.1, "centerLng": 49, "point1Lat": 24.16, "point1Lng": 49.06, "point2Lat": 24.04, "point2Lng": 48.94
    },
    {
        "id": 360, "name": "Harjah", "centerLat": 17.9, "centerLng": 43.3, "point1Lat": 17.96, "point1Lng": 43.36, "point2Lat": 17.84, "point2Lng": 43.24
    },
    {
        "id": 361, "name": "Jeddah Airport", "centerLat": 21.6794, "centerLng": 39.1558, "point1Lat": 21.72, "point1Lng": 39.2, "point2Lat": 21.64, "point2Lng": 39.1
    },
    {
        "id": 362, "name": "Khamasin", "centerLat": 20.3, "centerLng": 44.8, "point1Lat": 20.36, "point1Lng": 44.86, "point2Lat": 20.24, "point2Lng": 44.74
    },
    {
        "id": 363, "name": "King Khalid City", "centerLat": 27.97, "centerLng": 45.53, "point1Lat": 28.05, "point1Lng": 45.6, "point2Lat": 27.9, "point2Lng": 45.45
    },
    {
        "id": 364, "name": "Mukhwah", "centerLat": 19.78, "centerLng": 41.42, "point1Lat": 19.84, "point1Lng": 41.48, "point2Lat": 19.72, "point2Lng": 41.36
    },
    {
        "id": 365, "name": "Mulaija", "centerLat": 27, "centerLng": 48.2, "point1Lat": 27.06, "point1Lng": 48.26, "point2Lat": 26.94, "point2Lng": 48.14
    },
    {
        "id": 366, "name": "Muwayh", "centerLat": 22.43, "centerLng": 41.76, "point1Lat": 22.49, "point1Lng": 41.82, "point2Lat": 22.37, "point2Lng": 41.7
    },
    {
        "id": 367, "name": "Noweirieh", "centerLat": 27.49, "centerLng": 48.49, "point1Lat": 27.55, "point1Lng": 48.55, "point2Lat": 27.43, "point2Lng": 48.43
    },
    {
        "id": 368, "name": "Qarya Al Uliya", "centerLat": 27.6, "centerLng": 47.7, "point1Lat": 27.66, "point1Lng": 47.76, "point2Lat": 27.54, "point2Lng": 47.64
    },
    {
        "id": 369, "name": "Qaseem Airport", "centerLat": 26.3028, "centerLng": 43.7739, "point1Lat": 26.33, "point1Lng": 43.8, "point2Lat": 26.27, "point2Lng": 43.74
    },
    {
        "id": 370, "name": "Qaysumah", "centerLat": 28.31, "centerLng": 46.129, "point1Lat": 28.37, "point1Lng": 46.19, "point2Lat": 28.25, "point2Lng": 46.06
    },
    {
        "id": 371, "name": "Quwayiyah", "centerLat": 24.05, "centerLng": 45.25, "point1Lat": 24.11, "point1Lng": 45.31, "point2Lat": 23.99, "point2Lng": 45.19
    },
    {
        "id": 372, "name": "Rafayaa Al Gimsh", "centerLat": 24.75, "centerLng": 43.43, "point1Lat": 24.81, "point1Lng": 43.49, "point2Lat": 24.69, "point2Lng": 43.37
    },
    {
        "id": 373, "name": "Rahima", "centerLat": 26.7, "centerLng": 50, "point1Lat": 26.76, "point1Lng": 50.06, "point2Lat": 26.64, "point2Lng": 49.94
    },
    {
        "id": 374, "name": "Riyadh Airport", "centerLat": 24.9576, "centerLng": 46.7029, "point1Lat": 25, "point1Lng": 46.75, "point2Lat": 24.9, "point2Lng": 46.65
    },
    {
        "id": 375, "name": "Sapt Al Alaya", "centerLat": 19.55, "centerLng": 41.9, "point1Lat": 19.61, "point1Lng": 41.96, "point2Lat": 19.49, "point2Lng": 41.84
    },
    {
        "id": 376, "name": "Sarrar", "centerLat": 26.9, "centerLng": 48.6, "point1Lat": 26.96, "point1Lng": 48.66, "point2Lat": 26.84, "point2Lng": 48.54
    },
    {
        "id": 377, "name": "Sayirah", "centerLat": 27.8, "centerLng": 48.3, "point1Lat": 27.86, "point1Lng": 48.36, "point2Lat": 27.74, "point2Lng": 48.24
    },
    {
        "id": 378, "name": "Tanajib", "centerLat": 27.8, "centerLng": 48.8, "point1Lat": 27.86, "point1Lng": 48.86, "point2Lat": 27.74, "point2Lng": 48.74
    },
    {
        "id": 379, "name": "Tanumah", "centerLat": 18.995, "centerLng": 42.176, "point1Lat": 19.05, "point1Lng": 42.24, "point2Lat": 18.93, "point2Lng": 42.11
    },
    {
        "id": 380, "name": "Tathlith", "centerLat": 19.55, "centerLng": 43.5, "point1Lat": 19.61, "point1Lng": 43.56, "point2Lat": 19.49, "point2Lng": 43.44
    },
    {
        "id": 381, "name": "Thqbah", "centerLat": 26.2625, "centerLng": 50.1853, "point1Lat": 26.28, "point1Lng": 50.2, "point2Lat": 26.24, "point2Lng": 50.16
    },
    {
        "id": 382, "name": "Ula", "centerLat": 26.606, "centerLng": 37.92, "point1Lat": 26.66, "point1Lng": 37.98, "point2Lat": 26.54, "point2Lng": 37.86
    },
    {
        "id": 383, "name": "Uthmaniyah", "centerLat": 25.1, "centerLng": 49.3, "point1Lat": 25.16, "point1Lng": 49.36, "point2Lat": 25.04, "point2Lng": 49.24
    },
    {
        "id": 384, "name": "Wadeien", "centerLat": 18.4, "centerLng": 43.1, "point1Lat": 18.46, "point1Lng": 43.16, "point2Lat": 18.34, "point2Lng": 43.04
    },
    {
        "id": 385, "name": "Aba Alworood", "centerLat": 27.2, "centerLng": 43.9, "point1Lat": 27.26, "point1Lng": 43.96, "point2Lat": 27.14, "point2Lng": 43.84
    },
    {
        "id": 386, "name": "Abu Ajram", "centerLat": 29.8, "centerLng": 39, "point1Lat": 29.86, "point1Lng": 39.06, "point2Lat": 29.74, "point2Lng": 38.94
    },
    {
        "id": 387, "name": "Ad Dahinah", "centerLat": 25.3, "centerLng": 44.7, "point1Lat": 25.36, "point1Lng": 44.76, "point2Lat": 25.24, "point2Lng": 44.64
    },
    {
        "id": 388, "name": "Al Adari", "centerLat": 29.6, "centerLng": 38.5, "point1Lat": 29.66, "point1Lng": 38.56, "point2Lat": 29.54, "point2Lng": 38.44
    },
    {
        "id": 389, "name": "Al Ajfar", "centerLat": 27.4, "centerLng": 42.6, "point1Lat": 27.46, "point1Lng": 42.66, "point2Lat": 27.34, "point2Lng": 42.54
    },
    {
        "id": 390, "name": "Al Ammarah", "centerLat": 25.4, "centerLng": 44, "point1Lat": 25.46, "point1Lng": 44.06, "point2Lat": 25.34, "point2Lng": 43.94
    },
    {
        "id": 391, "name": "Al Arja", "centerLat": 24.3, "centerLng": 43.6, "point1Lat": 24.36, "point1Lng": 43.66, "point2Lat": 24.24, "point2Lng": 43.54
    },
    {
        "id": 392, "name": "Al Asyah", "centerLat": 26.6853, "centerLng": 43.6828, "point1Lat": 26.74, "point1Lng": 43.74, "point2Lat": 26.62, "point2Lng": 43.62
    },
    {
        "id": 393, "name": "Al Bada", "centerLat": 27.2, "centerLng": 36.6, "point1Lat": 27.26, "point1Lng": 36.66, "point2Lat": 27.14, "point2Lng": 36.54
    },
    {
        "id": 394, "name": "Al Batra", "centerLat": 25.2, "centerLng": 44.2, "point1Lat": 25.26, "point1Lng": 44.26, "point2Lat": 25.14, "point2Lng": 44.14
    },
    {
        "id": 395, "name": "Al Fuwaileq", "centerLat": 26.9, "centerLng": 43.1, "point1Lat": 26.96, "point1Lng": 43.16, "point2Lat": 26.84, "point2Lng": 43.04
    },
    {
        "id": 396, "name": "Al hait", "centerLat": 25.88, "centerLng": 40.58, "point1Lat": 25.94, "point1Lng": 40.64, "point2Lat": 25.82, "point2Lng": 40.52
    },
    {
        "id": 397, "name": "Al Haith", "centerLat": 25.88, "centerLng": 40.58, "point1Lat": 25.94, "point1Lng": 40.64, "point2Lat": 25.82, "point2Lng": 40.52
    },
    {
        "id": 398, "name": "Al Hufayyirah", "centerLat": 24.8, "centerLng": 44, "point1Lat": 24.86, "point1Lng": 44.06, "point2Lat": 24.74, "point2Lng": 43.94
    },
    {
        "id": 399, "name": "Al Idabi", "centerLat": 17.2, "centerLng": 42.9, "point1Lat": 17.26, "point1Lng": 42.96, "point2Lat": 17.14, "point2Lng": 42.84
    },
    {
        "id": 400, "name": "Al Khishaybi", "centerLat": 25.3, "centerLng": 43.1, "point1Lat": 25.36, "point1Lng": 43.16, "point2Lat": 25.24, "point2Lng": 43.04
    },
    {
        "id": 401, "name": "Al Laqayit", "centerLat": 30.1, "centerLng": 40.2, "point1Lat": 30.16, "point1Lng": 40.26, "point2Lat": 30.04, "point2Lng": 40.14
    },
    {
        "id": 402, "name": "Al Mada", "centerLat": 17.82, "centerLng": 43.34, "point1Lat": 17.88, "point1Lng": 43.4, "point2Lat": 17.76, "point2Lng": 43.28
    },
    {
        "id": 403, "name": "Al Mahd", "centerLat": 23.498, "centerLng": 40.855, "point1Lat": 23.55, "point1Lng": 40.91, "point2Lat": 23.43, "point2Lng": 40.79
    },
    {
        "id": 404, "name": "Al Midrij", "centerLat": 26.5, "centerLng": 42, "point1Lat": 26.56, "point1Lng": 42.06, "point2Lat": 26.44, "point2Lng": 41.94
    },
    {
        "id": 405, "name": "Al Moya", "centerLat": 25, "centerLng": 45, "point1Lat": 25.06, "point1Lng": 45.06, "point2Lat": 24.94, "point2Lng": 44.94
    },
    {
        "id": 406, "name": "Al Qarin", "centerLat": 26.6, "centerLng": 45.4, "point1Lat": 26.66, "point1Lng": 45.46, "point2Lat": 26.54, "point2Lng": 45.34
    },
    {
        "id": 407, "name": "Al Ruqi", "centerLat": 29, "centerLng": 46.5, "point1Lat": 29.06, "point1Lng": 46.56, "point2Lat": 28.94, "point2Lng": 46.44
    },
    {
        "id": 408, "name": "Al Wasayta", "centerLat": 26.4, "centerLng": 42.7, "point1Lat": 26.46, "point1Lng": 42.76, "point2Lat": 26.34, "point2Lng": 42.64
    },
    {
        "id": 409, "name": "Al-Jsh", "centerLat": 26.5416, "centerLng": 49.9323, "point1Lat": 26.56, "point1Lng": 49.95, "point2Lat": 26.52, "point2Lng": 49.91
    },
    {
        "id": 410, "name": "Amaq", "centerLat": 24, "centerLng": 43, "point1Lat": 24.06, "point1Lng": 43.06, "point2Lat": 23.94, "point2Lng": 42.94
    },
    {
        "id": 411, "name": "An Nabk Abu Qasr", "centerLat": 29.5, "centerLng": 38.8, "point1Lat": 29.56, "point1Lng": 38.86, "point2Lat": 29.44, "point2Lng": 38.74
    },
    {
        "id": 412, "name": "An Nafiah", "centerLat": 25.1, "centerLng": 43.8, "point1Lat": 25.16, "point1Lng": 43.86, "point2Lat": 25.04, "point2Lng": 43.74
    },
    {
        "id": 413, "name": "An Nuqrah", "centerLat": 25.6, "centerLng": 41.5, "point1Lat": 25.66, "point1Lng": 41.56, "point2Lat": 25.54, "point2Lng": 41.44
    },
    {
        "id": 414, "name": "Ar Radifah", "centerLat": 26.3, "centerLng": 41, "point1Lat": 26.36, "point1Lng": 41.06, "point2Lat": 26.24, "point2Lng": 40.94
    },
    {
        "id": 415, "name": "Ar Rishawiyah", "centerLat": 25, "centerLng": 41.8, "point1Lat": 25.06, "point1Lng": 41.86, "point2Lat": 24.94, "point2Lng": 41.74
    },
    {
        "id": 416, "name": "As Sulaimaniyah", "centerLat": 24.7, "centerLng": 46.8, "point1Lat": 24.76, "point1Lng": 46.86, "point2Lat": 24.64, "point2Lng": 46.74
    },
    {
        "id": 417, "name": "As Sulubiayh", "centerLat": 28.5, "centerLng": 44.5, "point1Lat": 28.56, "point1Lng": 44.56, "point2Lat": 28.44, "point2Lng": 44.44
    },
    {
        "id": 418, "name": "Ash Shaara", "centerLat": 24.9, "centerLng": 44.3, "point1Lat": 24.96, "point1Lng": 44.36, "point2Lat": 24.84, "point2Lng": 44.24
    },
    {
        "id": 419, "name": "Ash Shamli", "centerLat": 26.75, "centerLng": 40.1, "point1Lat": 26.81, "point1Lng": 40.16, "point2Lat": 26.69, "point2Lng": 40.04
    },
    {
        "id": 420, "name": "Ash Shananah", "centerLat": 25.8, "centerLng": 43.5, "point1Lat": 25.86, "point1Lng": 43.56, "point2Lat": 25.74, "point2Lng": 43.44
    },
    {
        "id": 421, "name": "At Tuwayr", "centerLat": 29.8, "centerLng": 40.3, "point1Lat": 29.86, "point1Lng": 40.36, "point2Lat": 29.74, "point2Lng": 40.24
    },
    {
        "id": 422, "name": "Badar Hunain", "centerLat": 23.778, "centerLng": 38.79, "point1Lat": 23.83, "point1Lng": 38.85, "point2Lat": 23.71, "point2Lng": 38.73
    },
    {
        "id": 423, "name": "Badr Al Janoub", "centerLat": 17.8, "centerLng": 43.9, "point1Lat": 17.86, "point1Lng": 43.96, "point2Lat": 17.74, "point2Lng": 43.84
    },
    {
        "id": 424, "name": "Bahrat Al Moujoud", "centerLat": 29.4, "centerLng": 38.3, "point1Lat": 29.46, "point1Lng": 38.36, "point2Lat": 29.34, "point2Lng": 38.24
    },
    {
        "id": 425, "name": "Balahmar", "centerLat": 18.7, "centerLng": 42.5, "point1Lat": 18.76, "point1Lng": 42.56, "point2Lat": 18.64, "point2Lng": 42.44
    },
    {
        "id": 426, "name": "Balasmar", "centerLat": 18.8, "centerLng": 42.3, "point1Lat": 18.86, "point1Lng": 42.36, "point2Lat": 18.74, "point2Lng": 42.24
    },
    {
        "id": 427, "name": "Balqarn", "centerLat": 19.3, "centerLng": 42, "point1Lat": 19.36, "point1Lng": 42.06, "point2Lat": 19.24, "point2Lng": 41.94
    },
    {
        "id": 428, "name": "Bani Malek", "centerLat": 20.3, "centerLng": 41, "point1Lat": 20.36, "point1Lng": 41.06, "point2Lat": 20.24, "point2Lng": 40.94
    },
    {
        "id": 429, "name": "Baqa Ash Sharqiyah", "centerLat": 27.7, "centerLng": 42.5, "point1Lat": 27.76, "point1Lng": 42.56, "point2Lat": 27.64, "point2Lng": 42.44
    },
    {
        "id": 430, "name": "Baqiq", "centerLat": 25.935, "centerLng": 49.6672, "point1Lat": 25.99, "point1Lng": 49.73, "point2Lat": 25.87, "point2Lng": 49.6
    },
    {
        "id": 431, "name": "Bashayer", "centerLat": 19.6, "centerLng": 41.8, "point1Lat": 19.66, "point1Lng": 41.86, "point2Lat": 19.54, "point2Lng": 41.74
    },
    {
        "id": 432, "name": "Birk", "centerLat": 18.3, "centerLng": 41.5, "point1Lat": 18.36, "point1Lng": 41.56, "point2Lat": 18.24, "point2Lng": 41.44
    },
    {
        "id": 433, "name": "Dammam Airport", "centerLat": 26.4711, "centerLng": 49.7979, "point1Lat": 26.52, "point1Lng": 49.85, "point2Lat": 26.42, "point2Lng": 49.74
    },
    {
        "id": 434, "name": "Deraab", "centerLat": 24.5, "centerLng": 46.5, "point1Lat": 24.56, "point1Lng": 46.56, "point2Lat": 24.44, "point2Lng": 46.44
    },
    {
        "id": 435, "name": "Dere'Iyeh", "centerLat": 24.7578, "centerLng": 46.576, "point1Lat": 24.82, "point1Lng": 46.64, "point2Lat": 24.69, "point2Lng": 46.51
    },
    {
        "id": 436, "name": "Dukhnah", "centerLat": 25.13, "centerLng": 42.66, "point1Lat": 25.19, "point1Lng": 42.72, "point2Lat": 25.07, "point2Lng": 42.6
    },
    {
        "id": 437, "name": "Dulay Rashid", "centerLat": 25.2, "centerLng": 42.4, "point1Lat": 25.26, "point1Lng": 42.46, "point2Lat": 25.14, "point2Lng": 42.34
    },
    {
        "id": 438, "name": "Hadeethah", "centerLat": 31.55, "centerLng": 37.15, "point1Lat": 31.61, "point1Lng": 37.21, "point2Lat": 31.49, "point2Lng": 37.09
    },
    {
        "id": 439, "name": "Hayer", "centerLat": 24.39, "centerLng": 46.85, "point1Lat": 24.45, "point1Lng": 46.91, "point2Lat": 24.33, "point2Lng": 46.79
    },
    {
        "id": 440, "name": "Hazm Al Jalamid", "centerLat": 31.06, "centerLng": 39.88, "point1Lat": 31.12, "point1Lng": 39.94, "point2Lat": 31, "point2Lng": 39.82
    },
    {
        "id": 441, "name": "Horaimal", "centerLat": 25.048, "centerLng": 46.155, "point1Lat": 25.1, "point1Lng": 46.21, "point2Lat": 24.98, "point2Lng": 46.09
    },
    {
        "id": 442, "name": "Ja'Araneh", "centerLat": 21.6, "centerLng": 39.9, "point1Lat": 21.66, "point1Lng": 39.96, "point2Lat": 21.54, "point2Lng": 39.84
    },
    {
        "id": 443, "name": "Jadidah Arar", "centerLat": 31.2, "centerLng": 41.2, "point1Lat": 31.26, "point1Lng": 41.26, "point2Lat": 31.14, "point2Lng": 41.14
    },
    {
        "id": 444, "name": "Jafar", "centerLat": 25.28, "centerLng": 49.72, "point1Lat": 25.34, "point1Lng": 49.78, "point2Lat": 25.22, "point2Lng": 49.66
    },
    {
        "id": 445, "name": "Kahlah", "centerLat": 17.5, "centerLng": 44.4, "point1Lat": 17.56, "point1Lng": 44.46, "point2Lat": 17.44, "point2Lng": 44.34
    },
    {
        "id": 446, "name": "Kamil", "centerLat": 22.2, "centerLng": 39.7, "point1Lat": 22.26, "point1Lng": 39.76, "point2Lat": 22.14, "point2Lng": 39.64
    },
    {
        "id": 447, "name": "Kara", "centerLat": 30.3, "centerLng": 40, "point1Lat": 30.36, "point1Lng": 40.06, "point2Lat": 30.24, "point2Lng": 39.94
    },
    {
        "id": 448, "name": "Kara'A", "centerLat": 16.9, "centerLng": 42.9, "point1Lat": 16.96, "point1Lng": 42.96, "point2Lat": 16.84, "point2Lng": 42.84
    },
    {
        "id": 449, "name": "Karboos", "centerLat": 16.8, "centerLng": 42.7, "point1Lat": 16.86, "point1Lng": 42.76, "point2Lat": 16.74, "point2Lng": 42.64
    },
    {
        "id": 450, "name": "Khairan", "centerLat": 28.7, "centerLng": 48.5, "point1Lat": 28.76, "point1Lng": 48.56, "point2Lat": 28.64, "point2Lng": 48.44
    },
    {
        "id": 451, "name": "Khamaseen", "centerLat": 20.3, "centerLng": 44.8, "point1Lat": 20.36, "point1Lng": 44.86, "point2Lat": 20.24, "point2Lng": 44.74
    },
    {
        "id": 452, "name": "Khasawyah", "centerLat": 17, "centerLng": 43.1, "point1Lat": 17.06, "point1Lng": 43.16, "point2Lat": 16.94, "point2Lng": 43.04
    },
    {
        "id": 453, "name": "Khodaria", "centerLat": 26.5, "centerLng": 50, "point1Lat": 26.56, "point1Lng": 50.06, "point2Lat": 26.44, "point2Lng": 49.94
    },
    {
        "id": 454, "name": "Kubadah", "centerLat": 26.83, "centerLng": 43.5, "point1Lat": 26.89, "point1Lng": 43.56, "point2Lat": 26.77, "point2Lng": 43.44
    },
    {
        "id": 455, "name": "Midinhab", "centerLat": 25.867, "centerLng": 44.217, "point1Lat": 25.92, "point1Lng": 44.28, "point2Lat": 25.8, "point2Lng": 44.15
    },
    {
        "id": 456, "name": "Moqaq", "centerLat": 27.3, "centerLng": 41.2, "point1Lat": 27.36, "point1Lng": 41.26, "point2Lat": 27.24, "point2Lng": 41.14
    },
    {
        "id": 457, "name": "Mubayid", "centerLat": 26.1, "centerLng": 47.7, "point1Lat": 26.16, "point1Lng": 47.76, "point2Lat": 26.04, "point2Lng": 47.64
    },
    {
        "id": 458, "name": "Mulayh", "centerLat": 27, "centerLng": 48.2, "point1Lat": 27.06, "point1Lng": 48.26, "point2Lat": 26.94, "point2Lng": 48.14
    },
    {
        "id": 459, "name": "Muneefa", "centerLat": 27.7, "centerLng": 49, "point1Lat": 27.76, "point1Lng": 49.06, "point2Lat": 27.64, "point2Lng": 48.94
    },
    {
        "id": 460, "name": "Munifat Al Qaid", "centerLat": 27.8, "centerLng": 41.7, "point1Lat": 27.86, "point1Lng": 41.76, "point2Lat": 27.74, "point2Lng": 41.64
    },
    {
        "id": 461, "name": "Nabaniya", "centerLat": 25.33, "centerLng": 42.82, "point1Lat": 25.39, "point1Lng": 42.88, "point2Lat": 25.27, "point2Lng": 42.76
    },
    {
        "id": 462, "name": "Nakeea", "centerLat": 24.3, "centerLng": 44.9, "point1Lat": 24.36, "point1Lng": 44.96, "point2Lat": 24.24, "point2Lng": 44.84
    },
    {
        "id": 463, "name": "Nifi", "centerLat": 25, "centerLng": 43.6, "point1Lat": 25.06, "point1Lng": 43.66, "point2Lat": 24.94, "point2Lng": 43.54
    },
    {
        "id": 464, "name": "Nisab", "centerLat": 28, "centerLng": 45, "point1Lat": 28.06, "point1Lng": 45.06, "point2Lat": 27.94, "point2Lng": 44.94
    },
    {
        "id": 465, "name": "Ojam", "centerLat": 26.57, "centerLng": 49.87, "point1Lat": 26.63, "point1Lng": 49.93, "point2Lat": 26.51, "point2Lng": 49.81
    },
    {
        "id": 466, "name": "Othmanyah", "centerLat": 25.1, "centerLng": 49.3, "point1Lat": 25.16, "point1Lng": 49.36, "point2Lat": 25.04, "point2Lng": 49.24
    },
    {
        "id": 467, "name": "Qahmah", "centerLat": 18.2, "centerLng": 41.8, "point1Lat": 18.26, "point1Lng": 41.86, "point2Lat": 18.14, "point2Lng": 41.74
    },
    {
        "id": 468, "name": "Qarah", "centerLat": 30.3, "centerLng": 40, "point1Lat": 30.36, "point1Lng": 40.06, "point2Lat": 30.24, "point2Lng": 39.94
    },
    {
        "id": 469, "name": "Qbah", "centerLat": 26.83, "centerLng": 43.5, "point1Lat": 26.89, "point1Lng": 43.56, "point2Lat": 26.77, "point2Lng": 43.44
    },
    {
        "id": 470, "name": "Qufar", "centerLat": 27.4, "centerLng": 41.6, "point1Lat": 27.46, "point1Lng": 41.66, "point2Lat": 27.34, "point2Lng": 41.54
    },
    {
        "id": 471, "name": "Qusayba", "centerLat": 26.8, "centerLng": 43.6, "point1Lat": 26.86, "point1Lng": 43.66, "point2Lat": 26.74, "point2Lng": 43.54
    },
    {
        "id": 472, "name": "Rawdat Habbas", "centerLat": 27.9, "centerLng": 45.2, "point1Lat": 27.96, "point1Lng": 45.26, "point2Lat": 27.84, "point2Lng": 45.14
    },
    {
        "id": 473, "name": "Rayn", "centerLat": 23.51, "centerLng": 45.47, "point1Lat": 23.57, "point1Lng": 45.53, "point2Lat": 23.45, "point2Lng": 45.41
    },
    {
        "id": 474, "name": "Sadyan", "centerLat": 26.5, "centerLng": 42.5, "point1Lat": 26.56, "point1Lng": 42.56, "point2Lat": 26.44, "point2Lng": 42.44
    },
    {
        "id": 475, "name": "Safanyah", "centerLat": 27.9, "centerLng": 48.7, "point1Lat": 27.96, "point1Lng": 48.76, "point2Lat": 27.84, "point2Lng": 48.64
    },
    {
        "id": 476, "name": "Sahna", "centerLat": 24.3, "centerLng": 44.5, "point1Lat": 24.36, "point1Lng": 44.56, "point2Lat": 24.24, "point2Lng": 44.44
    },
    {
        "id": 477, "name": "Saira", "centerLat": 27.8, "centerLng": 48.3, "point1Lat": 27.86, "point1Lng": 48.36, "point2Lat": 27.74, "point2Lng": 48.24
    },
    {
        "id": 478, "name": "Saqf", "centerLat": 27, "centerLng": 41, "point1Lat": 27.06, "point1Lng": 41.06, "point2Lat": 26.94, "point2Lng": 40.94
    },
    {
        "id": 479, "name": "Sayl Al Kabir", "centerLat": 21.6, "centerLng": 40.1, "point1Lat": 21.66, "point1Lng": 40.16, "point2Lat": 21.54, "point2Lng": 40.04
    },
    {
        "id": 480, "name": "Shaibah", "centerLat": 22.5, "centerLng": 53.9, "point1Lat": 22.56, "point1Lng": 53.96, "point2Lat": 22.44, "point2Lng": 53.84
    },
    {
        "id": 481, "name": "Shari", "centerLat": 26.7, "centerLng": 42.9, "point1Lat": 26.76, "point1Lng": 42.96, "point2Lat": 26.64, "point2Lng": 42.84
    },
    {
        "id": 482, "name": "Shedgum", "centerLat": 25.7, "centerLng": 49.3, "point1Lat": 25.76, "point1Lng": 49.36, "point2Lat": 25.64, "point2Lng": 49.24
    },
    {
        "id": 483, "name": "Shoaiba", "centerLat": 20.7, "centerLng": 39.5, "point1Lat": 20.76, "point1Lng": 39.56, "point2Lat": 20.64, "point2Lng": 39.44
    },
    {
        "id": 484, "name": "Shraie'E", "centerLat": 21.5, "centerLng": 39.9, "point1Lat": 21.56, "point1Lng": 39.96, "point2Lat": 21.44, "point2Lng": 39.84
    },
    {
        "id": 485, "name": "Simira", "centerLat": 26.5, "centerLng": 42, "point1Lat": 26.56, "point1Lng": 42.06, "point2Lat": 26.44, "point2Lng": 41.94
    },
    {
        "id": 486, "name": "Taiba", "centerLat": 26.3, "centerLng": 42.6, "point1Lat": 26.36, "point1Lng": 42.66, "point2Lat": 26.24, "point2Lng": 42.54
    },
    {
        "id": 487, "name": "Tanjeeb", "centerLat": 27.8, "centerLng": 48.8, "point1Lat": 27.86, "point1Lng": 48.86, "point2Lat": 27.74, "point2Lng": 48.74
    },
    {
        "id": 488, "name": "Tebrak", "centerLat": 23.9, "centerLng": 46, "point1Lat": 23.96, "point1Lng": 46.06, "point2Lat": 23.84, "point2Lng": 45.94
    },
    {
        "id": 489, "name": "Tharmada", "centerLat": 25.263, "centerLng": 45.541, "point1Lat": 25.32, "point1Lng": 45.6, "point2Lat": 25.2, "point2Lng": 45.48
    },
    {
        "id": 490, "name": "Thebea", "centerLat": 27.7, "centerLng": 44.9, "point1Lat": 27.76, "point1Lng": 44.96, "point2Lat": 27.64, "point2Lng": 44.84
    },
    {
        "id": 491, "name": "THUWAL", "centerLat": 22.303, "centerLng": 39.102, "point1Lat": 22.36, "point1Lng": 39.16, "point2Lat": 22.24, "point2Lng": 39.04
    },
    {
        "id": 492, "name": "Towal", "centerLat": 16.59, "centerLng": 43.15, "point1Lat": 16.65, "point1Lng": 43.21, "point2Lat": 16.53, "point2Lng": 43.09
    },
    {
        "id": 493, "name": "Um Aljamajim", "centerLat": 26.7, "centerLng": 45, "point1Lat": 26.76, "point1Lng": 45.06, "point2Lat": 26.64, "point2Lng": 44.94
    },
    {
        "id": 494, "name": "Ushayqir", "centerLat": 25.3, "centerLng": 45.3, "point1Lat": 25.36, "point1Lng": 45.36, "point2Lat": 25.24, "point2Lng": 45.24
    },
    {
        "id": 495, "name": "Uyun", "centerLat": 25.58, "centerLng": 49.58, "point1Lat": 25.64, "point1Lng": 49.64, "point2Lat": 25.52, "point2Lng": 49.52
    },
    {
        "id": 496, "name": "Uyun Al Jiwa", "centerLat": 26.5819, "centerLng": 43.6669, "point1Lat": 26.64, "point1Lng": 43.73, "point2Lat": 26.52, "point2Lng": 43.6
    },
    {
        "id": 497, "name": "Wadi Bin Hasbal", "centerLat": 18.508, "centerLng": 42.923, "point1Lat": 18.56, "point1Lng": 42.98, "point2Lat": 18.44, "point2Lng": 42.86
    },
    {
        "id": 498, "name": "Wadi Bin Hashbal", "centerLat": 18.508, "centerLng": 42.923, "point1Lat": 18.56, "point1Lng": 42.98, "point2Lat": 18.44, "point2Lng": 42.86
    },
    {
        "id": 499, "name": "Wadi Fatmah", "centerLat": 21.4, "centerLng": 39.6, "point1Lat": 21.46, "point1Lng": 39.66, "point2Lat": 21.34, "point2Lng": 39.54
    },
    {
        "id": 500, "name": "Wajeh (Al Wajh)", "centerLat": 26.23, "centerLng": 36.45, "point1Lat": 26.29, "point1Lng": 36.51, "point2Lat": 26.17, "point2Lng": 36.39
    },
    {
        "id": 501, "name": "Yanbu Al Baher", "centerLat": 24.0921, "centerLng": 38.0583, "point1Lat": 24.15, "point1Lng": 38.12, "point2Lat": 24.03, "point2Lng": 37.99
    },
    {
        "id": 502, "name": "Yanbu Nakhil", "centerLat": 24.2, "centerLng": 38.6, "point1Lat": 24.26, "point1Lng": 38.66, "point2Lat": 24.14, "point2Lng": 38.54
    },
    {
        "id": 503, "name": "Zallum", "centerLat": 30.13, "centerLng": 40, "point1Lat": 30.19, "point1Lng": 40.06, "point2Lat": 30.07, "point2Lng": 39.94
    },
    {
        "id": 504, "name": "Yanbu Al Nakhal", "centerLat": 24.2, "centerLng": 38.6, "point1Lat": 24.26, "point1Lng": 38.66, "point2Lat": 24.14, "point2Lng": 38.54
    },
    {
        "id": 505, "name": "Madinat Yanbu' as Sina'iyah", "centerLat": 23.98, "centerLng": 38.25, "point1Lat": 24.05, "point1Lng": 38.32, "point2Lat": 23.9, "point2Lng": 38.18
    },
    {
        "id": 506, "name": "Al Bashayer", "centerLat": 19.6, "centerLng": 41.8, "point1Lat": 19.66, "point1Lng": 41.86, "point2Lat": 19.54, "point2Lng": 41.74
    },
    {
        "id": 507, "name": "Al Dayer", "centerLat": 17.33, "centerLng": 43.13, "point1Lat": 17.39, "point1Lng": 43.19, "point2Lat": 17.27, "point2Lng": 43.07
    },
    {
        "id": 508, "name": "Ar Ruqi", "centerLat": 29, "centerLng": 46.5, "point1Lat": 29.06, "point1Lng": 46.56, "point2Lat": 28.94, "point2Lng": 46.44
    },
    {
        "id": 509, "name": "Asuwayq", "centerLat": 23.3, "centerLng": 57.4, "point1Lat": 23.36, "point1Lng": 57.46, "point2Lat": 23.24, "point2Lng": 57.34
    },
    {
        "id": 510, "name": "Ash Shuqayq", "centerLat": 17.6983, "centerLng": 42.029, "point1Lat": 17.75, "point1Lng": 42.08, "point2Lat": 17.64, "point2Lng": 41.97
    },
    {
        "id": 511, "name": "Al Atawlah", "centerLat": 20.1264, "centerLng": 41.3939, "point1Lat": 20.18, "point1Lng": 41.45, "point2Lat": 20.06, "point2Lng": 41.33
    },
    {
        "id": 512, "name": "Ayn lbn Fuhayd", "centerLat": 26.685, "centerLng": 43.669, "point1Lat": 26.71, "point1Lng": 43.7, "point2Lat": 26.65, "point2Lng": 43.63
    },
    {
        "id": 513, "name": "Al Ayun", "centerLat": 25.584, "centerLng": 49.579, "point1Lat": 25.61, "point1Lng": 49.61, "point2Lat": 25.55, "point2Lng": 49.54
    },
    {
        "id": 514, "name": "Al Bad", "centerLat": 28.784, "centerLng": 35.031, "point1Lat": 28.84, "point1Lng": 35.09, "point2Lat": 28.72, "point2Lng": 34.97
    },
    {
        "id": 515, "name": "Bahah", "centerLat": 20.0129, "centerLng": 41.4677, "point1Lat": 20.07, "point1Lng": 41.53, "point2Lat": 19.95, "point2Lng": 41.4
    },
    {
        "id": 516, "name": "Bani Malik", "centerLat": 17.301, "centerLng": 43.152, "point1Lat": 17.36, "point1Lng": 43.21, "point2Lat": 17.24, "point2Lng": 43.09
    },
    {
        "id": 517, "name": "Al Birk", "centerLat": 18.223, "centerLng": 41.583, "point1Lat": 18.28, "point1Lng": 41.64, "point2Lat": 18.16, "point2Lng": 41.52
    },
    {
        "id": 518, "name": "Dhalm", "centerLat": 22.705, "centerLng": 42.19, "point1Lat": 22.76, "point1Lng": 42.25, "point2Lat": 22.64, "point2Lng": 42.13
    },
    {
        "id": 519, "name": "Dahaban", "centerLat": 21.895, "centerLng": 39.12, "point1Lat": 21.95, "point1Lng": 39.18, "point2Lat": 21.83, "point2Lng": 39.06
    },
    {
        "id": 520, "name": "Dirab", "centerLat": 24.483, "centerLng": 46.592, "point1Lat": 24.54, "point1Lng": 46.65, "point2Lat": 24.42, "point2Lng": 46.53
    },
    {
        "id": 521, "name": "Hadda", "centerLat": 21.353, "centerLng": 40.28, "point1Lat": 21.41, "point1Lng": 40.34, "point2Lat": 21.29, "point2Lng": 40.22
    },
    {
        "id": 522, "name": "Haradh", "centerLat": 24.137, "centerLng": 49.061, "point1Lat": 24.19, "point1Lng": 49.12, "point2Lat": 24.07, "point2Lng": 49
    },
    {
        "id": 523, "name": "Al Huwaya", "centerLat": 21.4633, "centerLng": 40.4856, "point1Lat": 21.48, "point1Lng": 40.5, "point2Lat": 21.44, "point2Lng": 40.46
    },
    {
        "id": 524, "name": "Jash", "centerLat": 26.5416, "centerLng": 49.9323, "point1Lat": 26.56, "point1Lng": 49.95, "point2Lat": 26.52, "point2Lng": 49.91
    },
    {
        "id": 525, "name": "Al Kamil", "centerLat": 22.189, "centerLng": 39.712, "point1Lat": 22.24, "point1Lng": 39.77, "point2Lat": 22.12, "point2Lng": 39.65
    },
    {
        "id": 526, "name": "Al Laith", "centerLat": 20.147, "centerLng": 40.27, "point1Lat": 20.2, "point1Lng": 40.33, "point2Lat": 20.08, "point2Lng": 40.21
    },
    {
        "id": 527, "name": "Manifah", "centerLat": 27.7, "centerLng": 48.97, "point1Lat": 27.76, "point1Lng": 49.03, "point2Lat": 27.64, "point2Lng": 48.91
    },
    {
        "id": 528, "name": "Al Muwayh", "centerLat": 22.43, "centerLng": 41.76, "point1Lat": 22.49, "point1Lng": 41.82, "point2Lat": 22.37, "point2Lng": 41.7
    },
    {
        "id": 529, "name": "Mulayjah", "centerLat": 27, "centerLng": 48.2, "point1Lat": 27.06, "point1Lng": 48.26, "point2Lat": 26.94, "point2Lng": 48.14
    },
    {
        "id": 530, "name": "Al Mushaytiyah", "centerLat": 26.1167, "centerLng": 44.0333, "point1Lat": 26.17, "point1Lng": 44.09, "point2Lat": 26.05, "point2Lng": 43.97
    },
    {
        "id": 531, "name": "Al Nabah", "centerLat": 26.602, "centerLng": 49.889, "point1Lat": 26.66, "point1Lng": 49.95, "point2Lat": 26.54, "point2Lng": 49.82
    },
    {
        "id": 532, "name": "Al Qahma", "centerLat": 18.497, "centerLng": 41.745, "point1Lat": 18.55, "point1Lng": 41.8, "point2Lat": 18.43, "point2Lng": 41.68
    },
    {
        "id": 533, "name": "Al Qalibah", "centerLat": 27.945, "centerLng": 37.28, "point1Lat": 28, "point1Lng": 37.34, "point2Lat": 27.88, "point2Lng": 37.22
    },
    {
        "id": 534, "name": "Al Qarah", "centerLat": 25.412, "centerLng": 49.69, "point1Lat": 25.47, "point1Lng": 49.75, "point2Lat": 25.35, "point2Lng": 49.63
    },
    {
        "id": 535, "name": "Qina", "centerLat": 18.73, "centerLng": 42.02, "point1Lat": 18.79, "point1Lng": 42.08, "point2Lat": 18.67, "point2Lng": 41.96
    },
    {
        "id": 536, "name": "Rijal Alma", "centerLat": 18.2, "centerLng": 42.3, "point1Lat": 18.26, "point1Lng": 42.36, "point2Lat": 18.14, "point2Lng": 42.24
    },
    {
        "id": 537, "name": "Sabt Al Alayah", "centerLat": 19.55, "centerLng": 41.9, "point1Lat": 19.61, "point1Lng": 41.96, "point2Lat": 19.49, "point2Lng": 41.84
    },
    {
        "id": 538, "name": "As Saffaniyah", "centerLat": 27.97, "centerLng": 48.75, "point1Lat": 28.03, "point1Lng": 48.81, "point2Lat": 27.91, "point2Lng": 48.69
    },
    {
        "id": 539, "name": "As Sahna", "centerLat": 24.3, "centerLng": 44.5, "point1Lat": 24.36, "point1Lng": 44.56, "point2Lat": 24.24, "point2Lng": 44.44
    },
    {
        "id": 540, "name": "As Sail Al Kabeer", "centerLat": 21.61, "centerLng": 40.09, "point1Lat": 21.67, "point1Lng": 40.15, "point2Lat": 21.55, "point2Lng": 40.03
    },
    {
        "id": 541, "name": "Ash Shifa", "centerLat": 21.16, "centerLng": 40.38, "point1Lat": 21.22, "point1Lng": 40.44, "point2Lat": 21.1, "point2Lng": 40.32
    },
    {
        "id": 542, "name": "Shigry", "centerLat": 25.247, "centerLng": 45.253, "point1Lat": 25.3, "point1Lng": 45.31, "point2Lat": 25.18, "point2Lng": 45.19
    },
    {
        "id": 543, "name": "Tala'at Naza", "centerLat": 28.52, "centerLng": 36.83, "point1Lat": 28.58, "point1Lng": 36.89, "point2Lat": 28.46, "point2Lng": 36.77
    },
    {
        "id": 544, "name": "Tarib", "centerLat": 18.42, "centerLng": 42.66, "point1Lat": 18.48, "point1Lng": 42.72, "point2Lat": 18.36, "point2Lng": 42.6
    },
    {
        "id": 545, "name": "Umm Al Jamajm", "centerLat": 26.7, "centerLng": 45, "point1Lat": 26.76, "point1Lng": 45.06, "point2Lat": 26.64, "point2Lng": 44.94
    },
    {
        "id": 546, "name": "Al Wadeen", "centerLat": 18.4, "centerLng": 43.1, "point1Lat": 18.46, "point1Lng": 43.16, "point2Lat": 18.34, "point2Lng": 43.04
    },
    {
        "id": 547, "name": "Wadi Ibn Hasbal", "centerLat": 18.508, "centerLng": 42.923, "point1Lat": 18.56, "point1Lng": 42.98, "point2Lat": 18.44, "point2Lng": 42.86
    },
    {
        "id": 548, "name": "Hawea Taif", "centerLat": 21.4633, "centerLng": 40.4856, "point1Lat": 21.48, "point1Lng": 40.5, "point2Lat": 21.44, "point2Lng": 40.46
    },
    {
        "id": 549, "name": "Haweyah Dha", "centerLat": 21.4633, "centerLng": 40.4856, "point1Lat": 21.48, "point1Lng": 40.5, "point2Lat": 21.44, "point2Lng": 40.46
    },
    {
        "id": 550, "name": "Ardah", "centerLat": 19.248, "centerLng": 41.636, "point1Lat": 19.3, "point1Lng": 41.69, "point2Lat": 19.18, "point2Lng": 41.57
    },
    {
        "id": 551, "name": "Arja", "centerLat": 24.3, "centerLng": 43.6, "point1Lat": 24.36, "point1Lng": 43.66, "point2Lat": 24.24, "point2Lng": 43.54
    },
    {
        "id": 552, "name": "Al Wusayta", "centerLat": 26.398, "centerLng": 42.715, "point1Lat": 26.45, "point1Lng": 42.77, "point2Lat": 26.33, "point2Lng": 42.65
    },
    {
        "id": 553, "name": "Ash Shara'i`", "centerLat": 21.48, "centerLng": 39.95, "point1Lat": 21.54, "point1Lng": 40.01, "point2Lat": 21.42, "point2Lng": 39.89
    },
    {
        "id": 554, "name": "AlShinana", "centerLat": 25.84, "centerLng": 43.48, "point1Lat": 25.9, "point1Lng": 43.54, "point2Lat": 25.78, "point2Lng": 43.42
    },
    {
        "id": 555, "name": "Al Ju'ranah", "centerLat": 21.6, "centerLng": 39.9, "point1Lat": 21.66, "point1Lng": 39.96, "point2Lat": 21.54, "point2Lng": 39.84
    },
    {
        "id": 556, "name": "Kara'a", "centerLat": 16.9, "centerLng": 42.9, "point1Lat": 16.96, "point1Lng": 42.96, "point2Lat": 16.84, "point2Lng": 42.84
    },
    {
        "id": 557, "name": "Al Karbus", "centerLat": 16.8, "centerLng": 42.7, "point1Lat": 16.86, "point1Lng": 42.76, "point2Lat": 16.74, "point2Lng": 42.64
    },
    {
        "id": 558, "name": "Satorp Jubail Ind", "centerLat": 26.862, "centerLng": 49.601, "point1Lat": 26.92, "point1Lng": 49.66, "point2Lat": 26.8, "point2Lng": 49.54
    },
    {
        "id": 559, "name": "Al-Shemaysi", "centerLat": 21.34, "centerLng": 39.52, "point1Lat": 21.4, "point1Lng": 39.58, "point2Lat": 21.28, "point2Lng": 39.46
    },
    {
        "id": 560, "name": "Tayba", "centerLat": 26.3, "centerLng": 42.6, "point1Lat": 26.36, "point1Lng": 42.66, "point2Lat": 26.24, "point2Lng": 42.54
    },
    {
        "id": 561, "name": "At Taniem", "centerLat": 21.488, "centerLng": 39.789, "point1Lat": 21.54, "point1Lng": 39.84, "point2Lat": 21.42, "point2Lng": 39.72
    },
    {
        "id": 562, "name": "wadi alhali", "centerLat": 18.75, "centerLng": 41.55, "point1Lat": 18.81, "point1Lng": 41.61, "point2Lat": 18.69, "point2Lng": 41.49
    },
    {
        "id": 563, "name": "Haweyah/Dha", "centerLat": 21.4633, "centerLng": 40.4856, "point1Lat": 21.48, "point1Lng": 40.5, "point2Lat": 21.44, "point2Lng": 40.46
    },
    {
        "id": 564, "name": "Harajah", "centerLat": 17.9, "centerLng": 43.3, "point1Lat": 17.96, "point1Lng": 43.36, "point2Lat": 17.84, "point2Lng": 43.24
    },
    {
        "id": 565, "name": "Al-Maabuj", "centerLat": 16.91, "centerLng": 42.58, "point1Lat": 16.97, "point1Lng": 42.64, "point2Lat": 16.85, "point2Lng": 42.52
    },
    {
        "id": 566, "name": "Al-Asameliah", "centerLat": 16.63, "centerLng": 42.82, "point1Lat": 16.69, "point1Lng": 42.88, "point2Lat": 16.57, "point2Lng": 42.76
    },
    {
        "id": 567, "name": "Al-Wahla", "centerLat": 17.1, "centerLng": 42.7, "point1Lat": 17.16, "point1Lng": 42.76, "point2Lat": 17.04, "point2Lng": 42.64
    },
    {
        "id": 568, "name": "Bakhsha", "centerLat": 18.42, "centerLng": 42.44, "point1Lat": 18.48, "point1Lng": 42.5, "point2Lat": 18.36, "point2Lng": 42.38
    },
    {
        "id": 569, "name": "al fuqaha", "centerLat": 24.8, "centerLng": 39.9, "point1Lat": 24.86, "point1Lng": 39.96, "point2Lat": 24.74, "point2Lng": 39.84
    },
    {
        "id": 570, "name": "Al-Wasli", "centerLat": 16.8, "centerLng": 43, "point1Lat": 16.86, "point1Lng": 43.06, "point2Lat": 16.74, "point2Lng": 42.94
    },
    {
        "id": 571, "name": "Al-Rayyan", "centerLat": 24.71, "centerLng": 46.78, "point1Lat": 24.77, "point1Lng": 46.84, "point2Lat": 24.65, "point2Lng": 46.72
    },
    {
        "id": 572, "name": "Al-Khashabeya", "centerLat": 17, "centerLng": 43, "point1Lat": 17.06, "point1Lng": 43.06, "point2Lat": 16.94, "point2Lng": 42.94
    },
    {
        "id": 573, "name": "Shawajrah", "centerLat": 16.9, "centerLng": 42.9, "point1Lat": 16.96, "point1Lng": 42.96, "point2Lat": 16.84, "point2Lng": 42.84
    },
    {
        "id": 574, "name": "muhalih", "centerLat": 18.547, "centerLng": 42.046, "point1Lat": 18.6, "point1Lng": 42.1, "point2Lat": 18.48, "point2Lng": 41.98
    },
    {
        "id": 575, "name": "al kawamilih", "centerLat": 16.7, "centerLng": 42.8, "point1Lat": 16.76, "point1Lng": 42.86, "point2Lat": 16.64, "point2Lng": 42.74
    },
    {
        "id": 576, "name": "Al-Ashwah", "centerLat": 26.1, "centerLng": 41.5, "point1Lat": 26.16, "point1Lng": 41.56, "point2Lat": 26.04, "point2Lng": 41.44
    },
    {
        "id": 577, "name": "Al Dhabi", "centerLat": 25.9, "centerLng": 38.3, "point1Lat": 25.96, "point1Lng": 38.36, "point2Lat": 25.84, "point2Lng": 38.24
    },
    {
        "id": 578, "name": "Sanabah", "centerLat": 26.56, "centerLng": 50.07, "point1Lat": 26.62, "point1Lng": 50.13, "point2Lat": 26.5, "point2Lng": 50.01
    },
    {
        "id": 579, "name": "Taheria", "centerLat": 26.4, "centerLng": 50.1, "point1Lat": 26.46, "point1Lng": 50.16, "point2Lat": 26.34, "point2Lng": 50.04
    },
    {
        "id": 580, "name": "Al Hulwah", "centerLat": 23.51, "centerLng": 46.7, "point1Lat": 23.57, "point1Lng": 46.76, "point2Lat": 23.45, "point2Lng": 46.64
    },
    {
        "id": 581, "name": "AlQudaih", "centerLat": 26.57, "centerLng": 49.97, "point1Lat": 26.63, "point1Lng": 50.03, "point2Lat": 26.51, "point2Lng": 49.91
    },
    {
        "id": 582, "name": "malham", "centerLat": 25.137, "centerLng": 46.398, "point1Lat": 25.19, "point1Lng": 46.46, "point2Lat": 25.07, "point2Lng": 46.33
    },
    {
        "id": 583, "name": "alfaqir", "centerLat": 24.8, "centerLng": 39.9, "point1Lat": 24.86, "point1Lng": 39.96, "point2Lat": 24.74, "point2Lng": 39.84
    },
    {
        "id": 584, "name": "Abqaiq 2", "centerLat": 25.935, "centerLng": 49.6672, "point1Lat": 25.99, "point1Lng": 49.73, "point2Lat": 25.87, "point2Lng": 49.6
    },
    {
        "id": 585, "name": "Al-Amoah", "centerLat": 18.6, "centerLng": 43.2, "point1Lat": 18.66, "point1Lng": 43.26, "point2Lat": 18.54, "point2Lng": 43.14
    },
    {
        "id": 586, "name": "Al Araq", "centerLat": 17.6, "centerLng": 44.1, "point1Lat": 17.66, "point1Lng": 44.16, "point2Lat": 17.54, "point2Lng": 44.04
    },
    {
        "id": 587, "name": "Al Ardah 2", "centerLat": 19.248, "centerLng": 41.636, "point1Lat": 19.3, "point1Lng": 41.69, "point2Lat": 19.18, "point2Lng": 41.57
    },
    {
        "id": 588, "name": "Al Ashamiyah", "centerLat": 26.2, "centerLng": 45.1, "point1Lat": 26.26, "point1Lng": 45.16, "point2Lat": 26.14, "point2Lng": 45.04
    },
    {
        "id": 589, "name": "Al Awjam", "centerLat": 26.57, "centerLng": 49.87, "point1Lat": 26.63, "point1Lng": 49.93, "point2Lat": 26.51, "point2Lng": 49.81
    },
    {
        "id": 590, "name": "albadae", "centerLat": 26.0028, "centerLng": 43.7028, "point1Lat": 26.06, "point1Lng": 43.76, "point2Lat": 25.94, "point2Lng": 43.64
    },
    {
        "id": 591, "name": "wali_aleahd", "centerLat": 21.3, "centerLng": 39.8, "point1Lat": 21.36, "point1Lng": 39.86, "point2Lat": 21.24, "point2Lng": 39.74
    },
    {
        "id": 592, "name": "alamwah", "centerLat": 19.8, "centerLng": 43.7, "point1Lat": 19.86, "point1Lng": 43.76, "point2Lat": 19.74, "point2Lng": 43.64
    },
    {
        "id": 593, "name": "Sumaira", "centerLat": 26.5, "centerLng": 42, "point1Lat": 26.56, "point1Lng": 42.06, "point2Lat": 26.44, "point2Lng": 41.94
    },
    {
        "id": 594, "name": "alqahma", "centerLat": 18.497, "centerLng": 41.745, "point1Lat": 18.55, "point1Lng": 41.8, "point2Lat": 18.43, "point2Lng": 41.68
    },
    {
        "id": 595, "name": "Al Bada 2", "centerLat": 28.784, "centerLng": 35.031, "point1Lat": 28.84, "point1Lng": 35.09, "point2Lat": 28.72, "point2Lng": 34.97
    },
    {
        "id": 596, "name": "Alhada 2", "centerLat": 21.353, "centerLng": 40.28, "point1Lat": 21.41, "point1Lng": 40.34, "point2Lat": 21.29, "point2Lng": 40.22
    },
    {
        "id": 597, "name": "Al-Hadba", "centerLat": 17.4, "centerLng": 43.7, "point1Lat": 17.46, "point1Lng": 43.76, "point2Lat": 17.34, "point2Lng": 43.64
    },
    {
        "id": 598, "name": "Al Hudud Al Shamaliyah", "centerLat": 30, "centerLng": 42, "point1Lat": 32, "point1Lng": 47, "point2Lat": 28, "point2Lng": 38
    },
    {
        "id": 599, "name": "Al Jawf region", "centerLat": 29.5, "centerLng": 39.5, "point1Lat": 32, "point1Lng": 41, "point2Lat": 28, "point2Lng": 37
    },
    {
        "id": 600, "name": "Al Khaledah", "centerLat": 24.68, "centerLng": 46.68, "point1Lat": 24.74, "point1Lng": 46.74, "point2Lat": 24.62, "point2Lng": 46.62
    },
    {
        "id": 601, "name": "Al-Khobh", "centerLat": 16.4, "centerLng": 43.1, "point1Lat": 16.46, "point1Lng": 43.16, "point2Lat": 16.34, "point2Lng": 43.04
    },
    {
        "id": 602, "name": "Al Madinah Province", "centerLat": 24.5, "centerLng": 39.6, "point1Lat": 27.5, "point1Lng": 42.5, "point2Lat": 22.5, "point2Lng": 37
    },
    {
        "id": 603, "name": "Al Malida", "centerLat": 26.38, "centerLng": 43.89, "point1Lat": 26.44, "point1Lng": 43.95, "point2Lat": 26.32, "point2Lng": 43.83
    },
    {
        "id": 604, "name": "Al-Minkhali", "centerLat": 18.2, "centerLng": 47, "point1Lat": 18.26, "point1Lng": 47.06, "point2Lat": 18.14, "point2Lng": 46.94
    },
    {
        "id": 605, "name": "Al-Mishaliah", "centerLat": 17.65, "centerLng": 44.25, "point1Lat": 17.71, "point1Lng": 44.31, "point2Lat": 17.59, "point2Lng": 44.19
    },
    {
        "id": 606, "name": "Al Mundfin", "centerLat": 19.3, "centerLng": 41.6, "point1Lat": 19.36, "point1Lng": 41.66, "point2Lat": 19.24, "point2Lng": 41.54
    },
    {
        "id": 607, "name": "Al Nasim23", "centerLat": 24.7, "centerLng": 46.81, "point1Lat": 24.76, "point1Lng": 46.87, "point2Lat": 24.64, "point2Lng": 46.75
    },
    {
        "id": 608, "name": "Al Qahma 2", "centerLat": 18.497, "centerLng": 41.745, "point1Lat": 18.55, "point1Lng": 41.8, "point2Lat": 18.43, "point2Lng": 41.68
    },
    {
        "id": 609, "name": "Al-Reeth", "centerLat": 17.48, "centerLng": 43, "point1Lat": 17.54, "point1Lng": 43.06, "point2Lat": 17.42, "point2Lng": 42.94
    },
    {
        "id": 610, "name": "Al-Shuqaiq", "centerLat": 17.6983, "centerLng": 42.029, "point1Lat": 17.75, "point1Lng": 42.08, "point2Lat": 17.64, "point2Lng": 41.97
    },
    {
        "id": 611, "name": "Al-Wadiah", "centerLat": 17.27, "centerLng": 47.78, "point1Lat": 17.33, "point1Lng": 47.84, "point2Lat": 17.21, "point2Lng": 47.72
    },
    {
        "id": 612, "name": "Al Butayn", "centerLat": 26.33, "centerLng": 43.99, "point1Lat": 26.39, "point1Lng": 44.05, "point2Lat": 26.27, "point2Lng": 43.93
    },
    {
        "id": 613, "name": "Al Qaraa", "centerLat": 25.412, "centerLng": 49.69, "point1Lat": 25.47, "point1Lng": 49.75, "point2Lat": 25.35, "point2Lng": 49.63
    },
    {
        "id": 614, "name": "Al Rabiyah", "centerLat": 26.6, "centerLng": 43.8, "point1Lat": 26.66, "point1Lng": 43.86, "point2Lat": 26.54, "point2Lng": 43.74
    },
    {
        "id": 615, "name": "Amaq 2", "centerLat": 24, "centerLng": 43, "point1Lat": 24.06, "point1Lng": 43.06, "point2Lat": 23.94, "point2Lng": 42.94
    },
    {
        "id": 616, "name": "Anabqiyyah", "centerLat": 27.2, "centerLng": 44.4, "point1Lat": 27.26, "point1Lng": 44.46, "point2Lat": 27.14, "point2Lng": 44.34
    },
    {
        "id": 617, "name": "Aseer Province", "centerLat": 19, "centerLng": 43, "point1Lat": 21, "point1Lng": 45, "point2Lat": 17.5, "point2Lng": 41.5
    },
    {
        "id": 618, "name": "Asfan 2", "centerLat": 22, "centerLng": 39.3, "point1Lat": 22.06, "point1Lng": 39.36, "point2Lat": 21.94, "point2Lng": 39.24
    },
    {
        "id": 619, "name": "Assiyah", "centerLat": 26.6853, "centerLng": 43.6828, "point1Lat": 26.74, "point1Lng": 43.74, "point2Lat": 26.62, "point2Lng": 43.62
    },
    {
        "id": 620, "name": "At Taniem 2", "centerLat": 21.488, "centerLng": 39.789, "point1Lat": 21.54, "point1Lng": 39.84, "point2Lat": 21.42, "point2Lng": 39.72
    },
    {
        "id": 621, "name": "At Tarafiyah", "centerLat": 26.4, "centerLng": 44.1, "point1Lat": 26.46, "point1Lng": 44.16, "point2Lat": 26.34, "point2Lng": 44.04
    },
    {
        "id": 622, "name": "At Tarif Al Jadid", "centerLat": 24.75, "centerLng": 46.56, "point1Lat": 24.81, "point1Lng": 46.62, "point2Lat": 24.69, "point2Lng": 46.5
    },
    {
        "id": 623, "name": "At Tiraq", "centerLat": 26.8, "centerLng": 43.9, "point1Lat": 26.86, "point1Lng": 43.96, "point2Lat": 26.74, "point2Lng": 43.84
    },
    {
        "id": 624, "name": "Ayn Fuhayd", "centerLat": 26.685, "centerLng": 43.669, "point1Lat": 26.71, "point1Lng": 43.7, "point2Lat": 26.65, "point2Lng": 43.63
    },
    {
        "id": 625, "name": "Dereiyeh", "centerLat": 24.7578, "centerLng": 46.576, "point1Lat": 24.82, "point1Lng": 46.64, "point2Lat": 24.69, "point2Lng": 46.51
    },
    {
        "id": 626, "name": "Dilam", "centerLat": 23.9936, "centerLng": 47.1611, "point1Lat": 24.05, "point1Lng": 47.22, "point2Lat": 23.93, "point2Lng": 47.1
    },
    {
        "id": 627, "name": "Doos", "centerLat": 20.2, "centerLng": 41.3, "point1Lat": 20.26, "point1Lng": 41.36, "point2Lat": 20.14, "point2Lng": 41.24
    },
    {
        "id": 628, "name": "Eastern Province", "centerLat": 25, "centerLng": 50, "point1Lat": 32, "point1Lng": 55, "point2Lat": 22, "point2Lng": 47
    },
    {
        "id": 629, "name": "Hadithah", "centerLat": 31.55, "centerLng": 37.15, "point1Lat": 31.61, "point1Lng": 37.21, "point2Lat": 31.49, "point2Lng": 37.09
    },
    {
        "id": 630, "name": "Hail Province", "centerLat": 27.5, "centerLng": 41.7, "point1Lat": 29, "point1Lng": 44, "point2Lat": 25, "point2Lng": 39
    },
    {
        "id": 631, "name": "Hawaya", "centerLat": 21.4633, "centerLng": 40.4856, "point1Lat": 21.48, "point1Lng": 40.5, "point2Lat": 21.44, "point2Lng": 40.46
    },
    {
        "id": 632, "name": "Haweyah", "centerLat": 21.4633, "centerLng": 40.4856, "point1Lat": 21.48, "point1Lng": 40.5, "point2Lat": 21.44, "point2Lng": 40.46
    },
    {
        "id": 633, "name": "Ja'araneh", "centerLat": 21.6, "centerLng": 39.9, "point1Lat": 21.66, "point1Lng": 39.96, "point2Lat": 21.54, "point2Lng": 39.84
    },
    {
        "id": 634, "name": "Jarab", "centerLat": 25.8, "centerLng": 45, "point1Lat": 25.86, "point1Lng": 45.06, "point2Lat": 25.74, "point2Lng": 44.94
    },
    {
        "id": 635, "name": "Jizan", "centerLat": 17.3, "centerLng": 42.8, "point1Lat": 18, "point1Lng": 43.5, "point2Lat": 16.5, "point2Lng": 42.5
    },
    {
        "id": 636, "name": "Jouf al Alshoat", "centerLat": 30, "centerLng": 39.5, "point1Lat": 30.06, "point1Lng": 39.56, "point2Lat": 29.94, "point2Lng": 39.44
    },
    {
        "id": 637, "name": "Khbash", "centerLat": 17.5, "centerLng": 44.3, "point1Lat": 17.56, "point1Lng": 44.36, "point2Lat": 17.44, "point2Lng": 44.24
    },
    {
        "id": 638, "name": "Khulays", "centerLat": 22.148, "centerLng": 39.317, "point1Lat": 22.2, "point1Lng": 39.38, "point2Lat": 22.08, "point2Lng": 39.25
    },
    {
        "id": 639, "name": "Makkah Province", "centerLat": 21.5, "centerLng": 41, "point1Lat": 23, "point1Lng": 43, "point2Lat": 19, "point2Lng": 39
    },
    {
        "id": 640, "name": "Muwassam", "centerLat": 16.4, "centerLng": 42.9, "point1Lat": 16.46, "point1Lng": 42.96, "point2Lat": 16.34, "point2Lng": 42.84
    },
    {
        "id": 641, "name": "Najran Region", "centerLat": 18, "centerLng": 46, "point1Lat": 20, "point1Lng": 49, "point2Lat": 17, "point2Lng": 44
    },
    {
        "id": 642, "name": "Nimran", "centerLat": 21.2, "centerLng": 40.5, "point1Lat": 21.26, "point1Lng": 40.56, "point2Lat": 21.14, "point2Lng": 40.44
    },
    {
        "id": 643, "name": "Qariya A; Olaya", "centerLat": 27.6, "centerLng": 47.7, "point1Lat": 27.66, "point1Lng": 47.76, "point2Lat": 27.54, "point2Lng": 47.64
    },
    {
        "id": 644, "name": "Qusaiba", "centerLat": 26.8, "centerLng": 43.6, "point1Lat": 26.86, "point1Lng": 43.66, "point2Lat": 26.74, "point2Lng": 43.54
    },
    {
        "id": 645, "name": "Quwei'ieh", "centerLat": 24.05, "centerLng": 45.25, "point1Lat": 24.11, "point1Lng": 45.31, "point2Lat": 23.99, "point2Lng": 45.19
    },
    {
        "id": 646, "name": "Riyadh Province", "centerLat": 24, "centerLng": 45, "point1Lat": 27, "point1Lng": 48, "point2Lat": 20, "point2Lng": 42
    },
    {
        "id": 647, "name": "Samakh", "centerLat": 18, "centerLng": 42.7, "point1Lat": 18.06, "point1Lng": 42.76, "point2Lat": 17.94, "point2Lng": 42.64
    },
    {
        "id": 648, "name": "Sharurah", "centerLat": 17.478, "centerLng": 47.12, "point1Lat": 17.53, "point1Lng": 47.18, "point2Lat": 17.41, "point2Lng": 47.06
    },
    {
        "id": 649, "name": "Shifa", "centerLat": 21.16, "centerLng": 40.38, "point1Lat": 21.22, "point1Lng": 40.44, "point2Lat": 21.1, "point2Lng": 40.32
    },
    {
        "id": 650, "name": "Tabuk Province", "centerLat": 28, "centerLng": 37, "point1Lat": 29.5, "point1Lng": 39, "point2Lat": 26, "point2Lng": 35
    },
    {
        "id": 651, "name": "Thajir", "centerLat": 25.13, "centerLng": 44.57, "point1Lat": 25.19, "point1Lng": 44.63, "point2Lat": 25.07, "point2Lng": 44.51
    },
    {
        "id": 652, "name": "Tibrak", "centerLat": 23.9, "centerLng": 46, "point1Lat": 23.96, "point1Lng": 46.06, "point2Lat": 23.84, "point2Lng": 45.94
    },
    {
        "id": 653, "name": "Umm Lajj", "centerLat": 25.021, "centerLng": 37.268, "point1Lat": 25.08, "point1Lng": 37.33, "point2Lat": 24.96, "point2Lng": 37.2
    },
    {
        "id": 654, "name": "Unknown", "centerLat": 24.713552, "centerLng": 46.675296, "point1Lat": 25.127836, "point1Lng": 47.164391, "point2Lat": 24.406981, "point2Lng": 46.402778
    },
    {
        "id": 655, "name": "Uthal", "centerLat": 22.2, "centerLng": 39.2, "point1Lat": 22.26, "point1Lng": 39.26, "point2Lat": 22.14, "point2Lng": 39.14
    },
    {
        "id": 656, "name": "Wadi Ad Dawasir", "centerLat": 20.4667, "centerLng": 44.7833, "point1Lat": 20.53, "point1Lng": 44.85, "point2Lat": 20.4, "point2Lng": 44.71
    },
    {
        "id": 657, "name": "Yanbu Al Bahar", "centerLat": 24.0921, "centerLng": 38.0583, "point1Lat": 24.15, "point1Lng": 38.12, "point2Lat": 24.03, "point2Lng": 37.99
    },
    {
        "id": 658, "name": "Thar Najran", "centerLat": 18, "centerLng": 44.5, "point1Lat": 18.06, "point1Lng": 44.56, "point2Lat": 17.94, "point2Lng": 44.44
    },
    {
        "id": 659, "name": "ابو راكة", "centerLat": 26.9, "centerLng": 38.4, "point1Lat": 26.96, "point1Lng": 38.46, "point2Lat": 26.84, "point2Lng": 38.34
    },
    {
        "id": 660, "name": "KHAMIS ALBAHR", "centerLat": 18.6, "centerLng": 41.9, "point1Lat": 18.66, "point1Lng": 41.96, "point2Lat": 18.54, "point2Lng": 41.84
    },
    {
        "id": 661, "name": "القرى الشرقيه", "centerLat": 25.5, "centerLng": 49.8, "point1Lat": 25.56, "point1Lng": 49.86, "point2Lat": 25.44, "point2Lng": 49.74
    },
    {
        "id": 662, "name": "Darin", "centerLat": 26.54, "centerLng": 50.08, "point1Lat": 26.6, "point1Lng": 50.14, "point2Lat": 26.48, "point2Lng": 50.02
    },
    {
        "id": 663, "name": "Al Jubail Industrial", "centerLat": 27, "centerLng": 49.5, "point1Lat": 27.1, "point1Lng": 49.6, "point2Lat": 26.9, "point2Lng": 49.4
    },
    {
        "id": 664, "name": "الجوية", "centerLat": 25.9, "centerLng": 49, "point1Lat": 25.96, "point1Lng": 49.06, "point2Lat": 25.84, "point2Lng": 48.94
    },
    {
        "id": 665, "name": "جودة", "centerLat": 26.2, "centerLng": 48.9, "point1Lat": 26.26, "point1Lng": 48.96, "point2Lat": 26.14, "point2Lng": 48.84
    },
    {
        "id": 666, "name": "الغويبة", "centerLat": 25.6, "centerLng": 48.7, "point1Lat": 25.66, "point1Lng": 48.76, "point2Lat": 25.54, "point2Lng": 48.64
    },
    {
        "id": 667, "name": "انباك", "centerLat": 26, "centerLng": 48.6, "point1Lat": 26.06, "point1Lng": 48.66, "point2Lat": 25.94, "point2Lng": 48.54
    },
    {
        "id": 668, "name": "العديد دقم", "centerLat": 24.6, "centerLng": 51.3, "point1Lat": 24.66, "point1Lng": 51.36, "point2Lat": 24.54, "point2Lng": 51.24
    },
    {
        "id": 669, "name": "مريبطة", "centerLat": 25.8, "centerLng": 47.5, "point1Lat": 25.86, "point1Lng": 47.56, "point2Lat": 25.74, "point2Lng": 47.44
    },
    {
        "id": 670, "name": "الثليماء", "centerLat": 27.2, "centerLng": 46.5, "point1Lat": 27.26, "point1Lng": 46.56, "point2Lat": 27.14, "point2Lng": 46.44
    },
    {
        "id": 671, "name": "الجافورة", "centerLat": 25, "centerLng": 49.9, "point1Lat": 25.06, "point1Lng": 49.96, "point2Lat": 24.94, "point2Lng": 49.84
    },
    {
        "id": 672, "name": "أبو طينية", "centerLat": 28.1, "centerLng": 45.8, "point1Lat": 28.16, "point1Lng": 45.86, "point2Lat": 28.04, "point2Lng": 45.74
    },
    {
        "id": 673, "name": "عريعرة", "centerLat": 26.1, "centerLng": 48.6, "point1Lat": 26.16, "point1Lng": 48.66, "point2Lat": 26.04, "point2Lng": 48.54
    },
    {
        "id": 674, "name": "الطويلة", "centerLat": 25.7, "centerLng": 48.4, "point1Lat": 25.76, "point1Lng": 48.46, "point2Lat": 25.64, "point2Lng": 48.34
    },
    {
        "id": 675, "name": "فضيلة", "centerLat": 25.4333, "centerLng": 49.3333, "point1Lat": 25.49, "point1Lng": 49.39, "point2Lat": 25.37, "point2Lng": 49.27
    },
    {
        "id": 676, "name": "الحني", "centerLat": 25.9, "centerLng": 48.4, "point1Lat": 25.96, "point1Lng": 48.46, "point2Lat": 25.84, "point2Lng": 48.34
    },
    {
        "id": 677, "name": "السودة", "centerLat": 18.27, "centerLng": 42.37, "point1Lat": 18.33, "point1Lng": 42.43, "point2Lat": 18.21, "point2Lng": 42.31
    },
    {
        "id": 678, "name": "السيح", "centerLat": 24.15, "centerLng": 47.3, "point1Lat": 24.21, "point1Lng": 47.36, "point2Lat": 24.09, "point2Lng": 47.24
    },
    {
        "id": 679, "name": "الشجعة", "centerLat": 26.4, "centerLng": 48.1, "point1Lat": 26.46, "point1Lng": 48.16, "point2Lat": 26.34, "point2Lng": 48.04
    },
    {
        "id": 680, "name": "Silaa", "centerLat": 23.83, "centerLng": 51.78, "point1Lat": 23.89, "point1Lng": 51.84, "point2Lat": 23.77, "point2Lng": 51.72
    },
    {
        "id": 681, "name": "Thurayban", "centerLat": 19.3, "centerLng": 41.8, "point1Lat": 19.36, "point1Lng": 41.86, "point2Lat": 19.24, "point2Lng": 41.74
    },
    {
        "id": 682, "name": "AlBaha", "centerLat": 20.0129, "centerLng": 41.4677, "point1Lat": 20.07, "point1Lng": 41.53, "point2Lat": 19.95, "point2Lng": 41.4
    },
    {
        "id": 683, "name": "AlMakhwah", "centerLat": 19.78, "centerLng": 41.42, "point1Lat": 19.84, "point1Lng": 41.48, "point2Lat": 19.72, "point2Lng": 41.36
    },
    {
        "id": 684, "name": "AlAflaj", "centerLat": 22.3, "centerLng": 46.7, "point1Lat": 22.4, "point1Lng": 46.8, "point2Lat": 22.2, "point2Lng": 46.6
    },
    {
        "id": 685, "name": "Dumat alJandal", "centerLat": 29.811, "centerLng": 39.868, "point1Lat": 29.87, "point1Lng": 39.93, "point2Lat": 29.75, "point2Lng": 39.8
    },
    {
        "id": 686, "name": "zalom", "centerLat": 30.13, "centerLng": 40, "point1Lat": 30.19, "point1Lng": 40.06, "point2Lat": 30.07, "point2Lng": 39.94
    },
    {
        "id": 688, "name": "Abo Ajram", "centerLat": 29.8, "centerLng": 39, "point1Lat": 29.86, "point1Lng": 39.06, "point2Lat": 29.74, "point2Lng": 38.94
    },
    {
        "id": 689, "name": "Uyun al jawa", "centerLat": 26.5819, "centerLng": 43.6669, "point1Lat": 26.64, "point1Lng": 43.73, "point2Lat": 26.52, "point2Lng": 43.6
    },
    {
        "id": 690, "name": "Athuqbah", "centerLat": 26.2625, "centerLng": 50.1853, "point1Lat": 26.28, "point1Lng": 50.2, "point2Lat": 26.24, "point2Lng": 50.16
    },
    {
        "id": 691, "name": "AlAwamiyah", "centerLat": 26.58, "centerLng": 49.96, "point1Lat": 26.64, "point1Lng": 50.02, "point2Lat": 26.52, "point2Lng": 49.9
    },
    {
        "id": 692, "name": "AlQatif", "centerLat": 26.5714, "centerLng": 49.9961, "point1Lat": 26.63, "point1Lng": 50.05, "point2Lat": 26.51, "point2Lng": 49.93
    },
    {
        "id": 693, "name": "Afïf", "centerLat": 23.906, "centerLng": 42.921, "point1Lat": 23.96, "point1Lng": 42.98, "point2Lat": 23.84, "point2Lng": 42.86
    },
    {
        "id": 694, "name": "AbuAreesh", "centerLat": 16.9692, "centerLng": 42.8278, "point1Lat": 17, "point1Lng": 42.86, "point2Lat": 16.94, "point2Lng": 42.8
    },
    {
        "id": 695, "name": "Ahad AlMasarihah", "centerLat": 16.73, "centerLng": 42.85, "point1Lat": 16.79, "point1Lng": 42.91, "point2Lat": 16.67, "point2Lng": 42.79
    },
    {
        "id": 696, "name": "Ḍamad", "centerLat": 17.07, "centerLng": 42.87, "point1Lat": 17.13, "point1Lng": 42.93, "point2Lat": 17.01, "point2Lng": 42.81
    },
    {
        "id": 697, "name": "Hali AlQunfudhah", "centerLat": 18.75, "centerLng": 41.55, "point1Lat": 18.81, "point1Lng": 41.61, "point2Lat": 18.69, "point2Lng": 41.49
    },
    {
        "id": 698, "name": "hail", "centerLat": 27.525, "centerLng": 41.691, "point1Lat": 27.58, "point1Lng": 41.75, "point2Lat": 27.46, "point2Lng": 41.63
    },
    {
        "id": 699, "name": "Qaisumah", "centerLat": 28.31, "centerLng": 46.129, "point1Lat": 28.37, "point1Lng": 46.19, "point2Lat": 28.25, "point2Lng": 46.06
    },
    {
        "id": 700, "name": "hafar alBatin", "centerLat": 28.435, "centerLng": 45.968, "point1Lat": 28.5, "point1Lng": 46.03, "point2Lat": 28.37, "point2Lng": 45.9
    },
    {
        "id": 701, "name": "Udhayliyah", "centerLat": 25, "centerLng": 49.33, "point1Lat": 25.06, "point1Lng": 49.39, "point2Lat": 24.94, "point2Lng": 49.27
    },
    {
        "id": 702, "name": "AlUyun", "centerLat": 25.584, "centerLng": 49.579, "point1Lat": 25.61, "point1Lng": 49.61, "point2Lat": 25.55, "point2Lng": 49.54
    },
    {
        "id": 703, "name": "AlMubarraz", "centerLat": 25.419, "centerLng": 49.59, "point1Lat": 25.47, "point1Lng": 49.65, "point2Lat": 25.35, "point2Lng": 49.53
    },
    {
        "id": 704, "name": "Hassa", "centerLat": 25.3833, "centerLng": 49.5833, "point1Lat": 25.6, "point1Lng": 49.8, "point2Lat": 25.2, "point2Lng": 49.4
    },
    {
        "id": 705, "name": "AlJumoom", "centerLat": 21.61, "centerLng": 39.73, "point1Lat": 21.67, "point1Lng": 39.79, "point2Lat": 21.55, "point2Lng": 39.67
    },
    {
        "id": 706, "name": "Thwal", "centerLat": 22.303, "centerLng": 39.102, "point1Lat": 22.36, "point1Lng": 39.16, "point2Lat": 22.24, "point2Lng": 39.04
    },
    {
        "id": 707, "name": "Nairiyah", "centerLat": 27.49, "centerLng": 48.49, "point1Lat": 27.55, "point1Lng": 48.55, "point2Lat": 27.43, "point2Lng": 48.43
    },
    {
        "id": 708, "name": "AlKhafji", "centerLat": 28.421, "centerLng": 48.5, "point1Lat": 28.48, "point1Lng": 48.56, "point2Lat": 28.36, "point2Lng": 48.44
    },
    {
        "id": 709, "name": "Sabt AlUlayah", "centerLat": 19.55, "centerLng": 41.9, "point1Lat": 19.61, "point1Lng": 41.96, "point2Lat": 19.49, "point2Lng": 41.84
    },
    {
        "id": 710, "name": "Mahail", "centerLat": 18.547, "centerLng": 42.046, "point1Lat": 18.6, "point1Lng": 42.1, "point2Lat": 18.48, "point2Lng": 41.98
    },
    {
        "id": 711, "name": "Majardah", "centerLat": 19.12, "centerLng": 41.91, "point1Lat": 19.18, "point1Lng": 41.97, "point2Lat": 19.06, "point2Lng": 41.85
    },
    {
        "id": 712, "name": "Darb/abha", "centerLat": 17.722, "centerLng": 42.257, "point1Lat": 17.78, "point1Lng": 42.32, "point2Lat": 17.66, "point2Lng": 42.19
    },
    {
        "id": 713, "name": "Sarat Abideh", "centerLat": 18.257, "centerLng": 43.123, "point1Lat": 18.31, "point1Lng": 43.18, "point2Lat": 18.19, "point2Lng": 43.06
    },
    {
        "id": 714, "name": "AlKharj", "centerLat": 24.1574, "centerLng": 47.3101, "point1Lat": 24.22, "point1Lng": 47.37, "point2Lat": 24.09, "point2Lng": 47.25
    },
    {
        "id": 715, "name": "AdDilam", "centerLat": 23.9936, "centerLng": 47.1611, "point1Lat": 24.05, "point1Lng": 47.22, "point2Lat": 23.93, "point2Lng": 47.1
    },
    {
        "id": 716, "name": "Hotat Bani Tamim", "centerLat": 23.483, "centerLng": 46.758, "point1Lat": 23.54, "point1Lng": 46.82, "point2Lat": 23.42, "point2Lng": 46.69
    },
    {
        "id": 717, "name": "AlMajmaah", "centerLat": 25.9036, "centerLng": 45.3475, "point1Lat": 25.96, "point1Lng": 45.41, "point2Lat": 25.84, "point2Lng": 45.28
    },
    {
        "id": 718, "name": "Ghat", "centerLat": 26.01, "centerLng": 44.97, "point1Lat": 26.07, "point1Lng": 45.03, "point2Lat": 25.95, "point2Lng": 44.91
    },
    {
        "id": 719, "name": "Hawtat Sudayr", "centerLat": 25.626, "centerLng": 45.617, "point1Lat": 25.68, "point1Lng": 45.68, "point2Lat": 25.56, "point2Lng": 45.55
    },
    {
        "id": 720, "name": "AlUla", "centerLat": 26.606, "centerLng": 37.92, "point1Lat": 26.66, "point1Lng": 37.98, "point2Lat": 26.54, "point2Lng": 37.86
    },
    {
        "id": 721, "name": "AlBadai", "centerLat": 26.0028, "centerLng": 43.7028, "point1Lat": 26.06, "point1Lng": 43.76, "point2Lat": 25.94, "point2Lng": 43.64
    },
    {
        "id": 722, "name": "AlBukayriyah", "centerLat": 26.133, "centerLng": 43.65, "point1Lat": 26.19, "point1Lng": 43.71, "point2Lat": 26.07, "point2Lng": 43.59
    },
    {
        "id": 723, "name": "AlKhabra", "centerLat": 26.046, "centerLng": 43.597, "point1Lat": 26.1, "point1Lng": 43.66, "point2Lat": 25.98, "point2Lng": 43.53
    },
    {
        "id": 724, "name": "AlMidhnab", "centerLat": 25.867, "centerLng": 44.217, "point1Lat": 25.92, "point1Lng": 44.28, "point2Lat": 25.8, "point2Lng": 44.15
    },
    {
        "id": 725, "name": "Riyadh AlKhabra", "centerLat": 26.043, "centerLng": 43.618, "point1Lat": 26.1, "point1Lng": 43.68, "point2Lat": 25.98, "point2Lng": 43.55
    },
    {
        "id": 726, "name": "AlQuz", "centerLat": 19.78, "centerLng": 41.28, "point1Lat": 19.84, "point1Lng": 41.34, "point2Lat": 19.72, "point2Lng": 41.22
    },
    {
        "id": 727, "name": "Uqlat As Suqur", "centerLat": 25.75, "centerLng": 42.25, "point1Lat": 25.81, "point1Lng": 42.31, "point2Lat": 25.69, "point2Lng": 42.19
    },
    {
        "id": 728, "name": "AdDiriyah", "centerLat": 24.7578, "centerLng": 46.576, "point1Lat": 24.82, "point1Lng": 46.64, "point2Lat": 24.69, "point2Lng": 46.51
    },
    {
        "id": 729, "name": "AlQuwayiyah", "centerLat": 24.05, "centerLng": 45.25, "point1Lat": 24.11, "point1Lng": 45.31, "point2Lat": 23.99, "point2Lng": 45.19
    },
    {
        "id": 730, "name": "AlMuzahimiyah", "centerLat": 24.483, "centerLng": 46.275, "point1Lat": 24.54, "point1Lng": 46.33, "point2Lat": 24.42, "point2Lng": 46.21
    },
    {
        "id": 731, "name": "Shaqraa", "centerLat": 25.247, "centerLng": 45.253, "point1Lat": 25.3, "point1Lng": 45.31, "point2Lat": 25.18, "point2Lng": 45.19
    },
    {
        "id": 732, "name": "Alhawiyah", "centerLat": 21.4633, "centerLng": 40.4856, "point1Lat": 21.48, "point1Lng": 40.5, "point2Lat": 21.44, "point2Lng": 40.46
    },
    {
        "id": 733, "name": "Turabah", "centerLat": 21.215, "centerLng": 41.637, "point1Lat": 21.27, "point1Lng": 41.7, "point2Lat": 21.15, "point2Lng": 41.57
    },
    {
        "id": 734, "name": "haql", "centerLat": 29.3, "centerLng": 34.95, "point1Lat": 29.36, "point1Lng": 35.01, "point2Lat": 29.24, "point2Lng": 34.89
    },
    {
        "id": 735, "name": "Ḍuba", "centerLat": 27.351, "centerLng": 35.692, "point1Lat": 27.41, "point1Lng": 35.75, "point2Lat": 27.29, "point2Lng": 35.63
    },
    {
        "id": 736, "name": "AlQurayyat", "centerLat": 31.332, "centerLng": 37.361, "point1Lat": 31.39, "point1Lng": 37.42, "point2Lat": 31.27, "point2Lng": 37.3
    },
    {
        "id": 737, "name": "tabarjal", "centerLat": 30.5, "centerLng": 38.22, "point1Lat": 30.56, "point1Lng": 38.28, "point2Lat": 30.44, "point2Lng": 38.16
    },
    {
        "id": 738, "name": "Taraf", "centerLat": 25.3, "centerLng": 49.66, "point1Lat": 25.36, "point1Lng": 49.72, "point2Lat": 25.24, "point2Lng": 49.6
    },
    {
        "id": 739, "name": "Wadi adDawasir", "centerLat": 20.4667, "centerLng": 44.7833, "point1Lat": 20.53, "point1Lng": 44.85, "point2Lat": 20.4, "point2Lng": 44.71
    },
    {
        "id": 740, "name": "Ummluj", "centerLat": 25.021, "centerLng": 37.268, "point1Lat": 25.08, "point1Lng": 37.33, "point2Lat": 24.96, "point2Lng": 37.2
    },
    {
        "id": 741, "name": "AlWajh", "centerLat": 26.23, "centerLng": 36.45, "point1Lat": 26.29, "point1Lng": 36.51, "point2Lat": 26.17, "point2Lng": 36.39
    },
    {
        "id": 742, "name": "banni hassan", "centerLat": 20.08, "centerLng": 41.35, "point1Lat": 20.14, "point1Lng": 41.41, "point2Lat": 20.02, "point2Lng": 41.29
    },
    {
        "id": 743, "name": "AL DAGHARER", "centerLat": 16.7, "centerLng": 42.95, "point1Lat": 16.76, "point1Lng": 43.01, "point2Lat": 16.64, "point2Lng": 42.89
    },
    {
        "id": 744, "name": "Mubarraz", "centerLat": 25.419, "centerLng": 49.59, "point1Lat": 25.47, "point1Lng": 49.65, "point2Lat": 25.35, "point2Lng": 49.53
    },
    {
        "id": 745, "name": "Qassim", "centerLat": 26.333333, "centerLng": 43.966667, "point1Lat": 27.5, "point1Lng": 45, "point2Lat": 25, "point2Lng": 42.5
    },
    {
        "id": 746, "name": "Qaryat alsafra", "centerLat": 22.8, "centerLng": 39.5, "point1Lat": 22.86, "point1Lng": 39.56, "point2Lat": 22.74, "point2Lng": 39.44
    },
    {
        "id": 747, "name": "Qaryat marghan", "centerLat": 23.2, "centerLng": 40, "point1Lat": 23.26, "point1Lng": 40.06, "point2Lat": 23.14, "point2Lng": 39.94
    },
    {
        "id": 748, "name": "Qaryat almaerish", "centerLat": 23, "centerLng": 40.5, "point1Lat": 23.06, "point1Lng": 40.56, "point2Lat": 22.94, "point2Lng": 40.44
    },
    {
        "id": 749, "name": "Qaryat rud bin hadi", "centerLat": 23.5, "centerLng": 41, "point1Lat": 23.56, "point1Lng": 41.06, "point2Lat": 23.44, "point2Lng": 40.94
    },
    {
        "id": 750, "name": "Qaryat murahab", "centerLat": 25.8, "centerLng": 39.3, "point1Lat": 25.86, "point1Lng": 39.36, "point2Lat": 25.74, "point2Lng": 39.24
    },
    {
        "id": 751, "name": "Qaryat alkhafij", "centerLat": 26, "centerLng": 40.2, "point1Lat": 26.06, "point1Lng": 40.26, "point2Lat": 25.94, "point2Lng": 40.14
    },
    {
        "id": 752, "name": "Qaryat aleiradia", "centerLat": 26.2, "centerLng": 40.8, "point1Lat": 26.26, "point1Lng": 40.86, "point2Lat": 26.14, "point2Lng": 40.74
    },
    {
        "id": 753, "name": "Qaryat alraqab", "centerLat": 26.4, "centerLng": 41.2, "point1Lat": 26.46, "point1Lng": 41.26, "point2Lat": 26.34, "point2Lng": 41.14
    },
    {
        "id": 754, "name": "Qaryat alwasita", "centerLat": 26.398, "centerLng": 42.715, "point1Lat": 26.45, "point1Lng": 42.77, "point2Lat": 26.33, "point2Lng": 42.65
    },
    {
        "id": 755, "name": "Qaryat almaghar", "centerLat": 26.1, "centerLng": 41.9, "point1Lat": 26.16, "point1Lng": 41.96, "point2Lat": 26.04, "point2Lng": 41.84
    },
    {
        "id": 756, "name": "alhalifat aleulya", "centerLat": 25.8, "centerLng": 40.9, "point1Lat": 25.86, "point1Lng": 40.96, "point2Lat": 25.74, "point2Lng": 40.84
    },
    {
        "id": 757, "name": "qaryat almakhruq", "centerLat": 25.6, "centerLng": 41.3, "point1Lat": 25.66, "point1Lng": 41.36, "point2Lat": 25.54, "point2Lng": 41.24
    },
    {
        "id": 758, "name": "qaryat albarika", "centerLat": 25.4, "centerLng": 41.7, "point1Lat": 25.46, "point1Lng": 41.76, "point2Lat": 25.34, "point2Lng": 41.64
    },
    {
        "id": 759, "name": "qaryat 'am rwshn", "centerLat": 25.2, "centerLng": 42.1, "point1Lat": 25.26, "point1Lng": 42.16, "point2Lat": 25.14, "point2Lng": 42.04
    },
    {
        "id": 760, "name": "qaryat alsafit", "centerLat": 25, "centerLng": 42.5, "point1Lat": 25.06, "point1Lng": 42.56, "point2Lat": 24.94, "point2Lng": 42.44
    },
    {
        "id": 761, "name": "qaryat wasaeat alrasi", "centerLat": 24.8, "centerLng": 42.9, "point1Lat": 24.86, "point1Lng": 42.96, "point2Lat": 24.74, "point2Lng": 42.84
    },
    {
        "id": 762, "name": "qaryat fidat athqab", "centerLat": 24.6, "centerLng": 43.3, "point1Lat": 24.66, "point1Lng": 43.36, "point2Lat": 24.54, "point2Lng": 43.24
    },
    {
        "id": 763, "name": "Safoa", "centerLat": 26.6569, "centerLng": 49.9722, "point1Lat": 26.71, "point1Lng": 50.03, "point2Lat": 26.59, "point2Lng": 49.91
    },
    {
        "id": 764, "name": "Baqaiq", "centerLat": 25.935, "centerLng": 49.6672, "point1Lat": 25.99, "point1Lng": 49.73, "point2Lat": 25.87, "point2Lng": 49.6
    },
    {
        "id": 765, "name": "Madinatal Umran", "centerLat": 25.26, "centerLng": 49.58, "point1Lat": 25.32, "point1Lng": 49.64, "point2Lat": 25.2, "point2Lng": 49.52
    },
    {
        "id": 766, "name": "Madinat Al Jafr", "centerLat": 25.28, "centerLng": 49.72, "point1Lat": 25.34, "point1Lng": 49.78, "point2Lat": 25.22, "point2Lng": 49.66
    },
    {
        "id": 767, "name": "Al-Oyoon", "centerLat": 25.584, "centerLng": 49.579, "point1Lat": 25.61, "point1Lng": 49.61, "point2Lat": 25.55, "point2Lng": 49.54
    },
    {
        "id": 768, "name": "Al Bujiri", "centerLat": 24.75, "centerLng": 46.58, "point1Lat": 24.81, "point1Lng": 46.64, "point2Lat": 24.69, "point2Lng": 46.52
    },
    {
        "id": 769, "name": "Al Diriyah", "centerLat": 24.7578, "centerLng": 46.576, "point1Lat": 24.82, "point1Lng": 46.64, "point2Lat": 24.69, "point2Lng": 46.51
    },
    {
        "id": 770, "name": "Al Thimamiyah", "centerLat": 25.2, "centerLng": 46.7, "point1Lat": 25.26, "point1Lng": 46.76, "point2Lat": 25.14, "point2Lng": 46.64
    },
    {
        "id": 771, "name": "الشقة", "centerLat": 26.4, "centerLng": 43.95, "point1Lat": 26.46, "point1Lng": 44.01, "point2Lat": 26.34, "point2Lng": 43.89
    },
    {
        "id": 772, "name": "Rubayiyah", "centerLat": 26.5, "centerLng": 44.05, "point1Lat": 26.56, "point1Lng": 44.11, "point2Lat": 26.44, "point2Lng": 43.99
    },
    {
        "id": 773, "name": "Turfiyah al Gharbiyah", "centerLat": 26.55, "centerLng": 44, "point1Lat": 26.61, "point1Lng": 44.06, "point2Lat": 26.49, "point2Lng": 43.94
    },
    {
        "id": 774, "name": "النبقية", "centerLat": 26.65, "centerLng": 44.1, "point1Lat": 26.71, "point1Lng": 44.16, "point2Lat": 26.59, "point2Lng": 44.04
    },
    {
        "id": 775, "name": "qaryat alsalsalih", "centerLat": 26.8, "centerLng": 44.2, "point1Lat": 26.86, "point1Lng": 44.26, "point2Lat": 26.74, "point2Lng": 44.14
    },
    {
        "id": 776, "name": "qaryat rahbat alhasni", "centerLat": 26.95, "centerLng": 44.3, "point1Lat": 27.01, "point1Lng": 44.36, "point2Lat": 26.89, "point2Lng": 44.24
    },
    {
        "id": 777, "name": "qaryat zubran", "centerLat": 27.1, "centerLng": 44.4, "point1Lat": 27.16, "point1Lng": 44.46, "point2Lat": 27.04, "point2Lng": 44.34
    },
    {
        "id": 778, "name": "dalfah", "centerLat": 25.6, "centerLng": 43, "point1Lat": 25.66, "point1Lng": 43.06, "point2Lat": 25.54, "point2Lng": 42.94
    },
    {
        "id": 779, "name": "Sanabis", "centerLat": 26.56, "centerLng": 50.07, "point1Lat": 26.62, "point1Lng": 50.13, "point2Lat": 26.5, "point2Lng": 50.01
    },
    {
        "id": 780, "name": "Makkah al Mukarramah", "centerLat": 21.42251, "centerLng": 39.826168, "point1Lat": 21.585792, "point1Lng": 39.959998, "point2Lat": 21.265939, "point2Lng": 39.690553
    },
    {
        "id": 781, "name": "al Madinah al Munawwarah", "centerLat": 24.468611, "centerLng": 39.614167, "point1Lat": 24.577232, "point1Lng": 39.73359, "point2Lat": 24.385714, "point2Lng": 39.510825
    },
    {
        "id": 782, "name": "al Jumum", "centerLat": 21.61, "centerLng": 39.73, "point1Lat": 21.67, "point1Lng": 39.79, "point2Lat": 21.55, "point2Lng": 39.67
    },
    {
        "id": 783, "name": "Jubail Al Balad", "centerLat": 27.0049, "centerLng": 49.6582, "point1Lat": 27.07, "point1Lng": 49.72, "point2Lat": 26.94, "point2Lng": 49.59
    },
    {
        "id": 784, "name": "Jubail Industrial", "centerLat": 27, "centerLng": 49.5, "point1Lat": 27.1, "point1Lng": 49.6, "point2Lat": 26.9, "point2Lng": 49.4
    },
    {
        "id": 785, "name": "Umm Al Sahek", "centerLat": 26.69, "centerLng": 49.8, "point1Lat": 26.75, "point1Lng": 49.86, "point2Lat": 26.63, "point2Lng": 49.74
    },
    {
        "id": 786, "name": "Al-Kharj", "centerLat": 24.1574, "centerLng": 47.3101, "point1Lat": 24.22, "point1Lng": 47.37, "point2Lat": 24.09, "point2Lng": 47.25
    },
    {
        "id": 787, "name": "Majma'ah", "centerLat": 25.9036, "centerLng": 45.3475, "point1Lat": 25.96, "point1Lng": 45.41, "point2Lat": 25.84, "point2Lng": 45.28
    },
    {
        "id": 788, "name": "Al-Artawiyah", "centerLat": 26.54, "centerLng": 45.33, "point1Lat": 26.6, "point1Lng": 45.39, "point2Lat": 26.48, "point2Lng": 45.27
    },
    {
        "id": 789, "name": "Al-Muzahimiyah", "centerLat": 24.483, "centerLng": 46.275, "point1Lat": 24.54, "point1Lng": 46.33, "point2Lat": 24.42, "point2Lng": 46.21
    },
    {
        "id": 790, "name": "Al-Dahna", "centerLat": 25.3, "centerLng": 44.7, "point1Lat": 25.36, "point1Lng": 44.76, "point2Lat": 25.24, "point2Lng": 44.64
    },
    {
        "id": 791, "name": "Rawdat Sudair", "centerLat": 25.753, "centerLng": 45.548, "point1Lat": 25.81, "point1Lng": 45.61, "point2Lat": 25.69, "point2Lng": 45.48
    },
    {
        "id": 792, "name": "Sudair clan", "centerLat": 25.6, "centerLng": 45.6, "point1Lat": 25.9, "point1Lng": 45.9, "point2Lat": 25.3, "point2Lng": 45.3
    },
    {
        "id": 793, "name": "Umm Sidra", "centerLat": 26, "centerLng": 45.8, "point1Lat": 26.06, "point1Lng": 45.86, "point2Lat": 25.94, "point2Lng": 45.74
    },
    {
        "id": 794, "name": "Uhud Al-Masarha", "centerLat": 16.73, "centerLng": 42.85, "point1Lat": 16.79, "point1Lng": 42.91, "point2Lat": 16.67, "point2Lng": 42.79
    },
    {
        "id": 795, "name": "Uhud Rafidah", "centerLat": 18.1969, "centerLng": 42.8256, "point1Lat": 18.25, "point1Lng": 42.88, "point2Lat": 18.13, "point2Lng": 42.76
    },
    {
        "id": 796, "name": "Baysh", "centerLat": 17.38, "centerLng": 42.53, "point1Lat": 17.44, "point1Lng": 42.59, "point2Lat": 17.32, "point2Lng": 42.47
    },
    {
        "id": 797, "name": "Al-Shaqiq", "centerLat": 17.6983, "centerLng": 42.029, "point1Lat": 17.75, "point1Lng": 42.08, "point2Lat": 17.64, "point2Lng": 41.97
    },
    {
        "id": 798, "name": "Al-Darb", "centerLat": 17.722, "centerLng": 42.257, "point1Lat": 17.78, "point1Lng": 42.32, "point2Lat": 17.66, "point2Lng": 42.19
    },
    {
        "id": 799, "name": "Sarat Obaid", "centerLat": 18.257, "centerLng": 43.123, "point1Lat": 18.31, "point1Lng": 43.18, "point2Lat": 18.19, "point2Lng": 43.06
    },
    {
        "id": 800, "name": "Al-Bada'i", "centerLat": 26.0028, "centerLng": 43.7028, "point1Lat": 26.06, "point1Lng": 43.76, "point2Lat": 25.94, "point2Lng": 43.64
    },
    {
        "id": 801, "name": "Al-Bukairiyah", "centerLat": 26.133, "centerLng": 43.65, "point1Lat": 26.19, "point1Lng": 43.71, "point2Lat": 26.07, "point2Lng": 43.59
    },
    {
        "id": 802, "name": "Al-Khubra", "centerLat": 26.046, "centerLng": 43.597, "point1Lat": 26.1, "point1Lng": 43.66, "point2Lat": 25.98, "point2Lng": 43.53
    },
    {
        "id": 803, "name": "Riyadh Al-Khubra", "centerLat": 26.043, "centerLng": 43.618, "point1Lat": 26.1, "point1Lng": 43.68, "point2Lat": 25.98, "point2Lng": 43.55
    },
    {
        "id": 804, "name": "Al-Rass", "centerLat": 25.8697, "centerLng": 43.5019, "point1Lat": 25.93, "point1Lng": 43.56, "point2Lat": 25.8, "point2Lng": 43.44
    },
    {
        "id": 805, "name": "Al-Nabhaniyah", "centerLat": 25.33, "centerLng": 42.82, "point1Lat": 25.39, "point1Lng": 42.88, "point2Lat": 25.27, "point2Lng": 42.76
    },
    {
        "id": 806, "name": "Al-Shamsiyah", "centerLat": 26.54, "centerLng": 44.38, "point1Lat": 26.6, "point1Lng": 44.44, "point2Lat": 26.48, "point2Lng": 44.32
    },
    {
        "id": 807, "name": "Al-Mathnb", "centerLat": 25.867, "centerLng": 44.217, "point1Lat": 25.92, "point1Lng": 44.28, "point2Lat": 25.8, "point2Lng": 44.15
    },
    {
        "id": 808, "name": "Oyoun Al-Jawa", "centerLat": 26.5819, "centerLng": 43.6669, "point1Lat": 26.64, "point1Lng": 43.73, "point2Lat": 26.52, "point2Lng": 43.6
    },
    {
        "id": 809, "name": "Rathaya", "centerLat": 25.7, "centerLng": 43.4, "point1Lat": 25.76, "point1Lng": 43.46, "point2Lat": 25.64, "point2Lng": 43.34
    },
    {
        "id": 810, "name": "Suwaidhrah", "centerLat": 24.9, "centerLng": 40.2, "point1Lat": 24.96, "point1Lng": 40.26, "point2Lat": 24.84, "point2Lng": 40.14
    },
    {
        "id": 811, "name": "Sheqran", "centerLat": 24.6, "centerLng": 39.8, "point1Lat": 24.66, "point1Lng": 39.86, "point2Lat": 24.54, "point2Lng": 39.74
    },
    {
        "id": 812, "name": "Mindassah", "centerLat": 24.7, "centerLng": 39.2, "point1Lat": 24.76, "point1Lng": 39.26, "point2Lat": 24.64, "point2Lng": 39.14
    },
    {
        "id": 813, "name": "Mulaylih", "centerLat": 24.6, "centerLng": 39.4, "point1Lat": 24.66, "point1Lng": 39.46, "point2Lat": 24.54, "point2Lng": 39.34
    },
    {
        "id": 814, "name": "Selselah", "centerLat": 24, "centerLng": 41.5, "point1Lat": 24.06, "point1Lng": 41.56, "point2Lat": 23.94, "point2Lng": 41.44
    },
    {
        "id": 815, "name": "Bir Al Mashi", "centerLat": 24.31, "centerLng": 39.42, "point1Lat": 24.37, "point1Lng": 39.48, "point2Lat": 24.25, "point2Lng": 39.36
    },
    {
        "id": 816, "name": "Ushyrah", "centerLat": 21.8, "centerLng": 40.76, "point1Lat": 21.86, "point1Lng": 40.82, "point2Lat": 21.74, "point2Lng": 40.7
    },
    {
        "id": 817, "name": "Wadi Reem", "centerLat": 24.1, "centerLng": 39.9, "point1Lat": 24.16, "point1Lng": 39.96, "point2Lat": 24.04, "point2Lng": 39.84
    },
    {
        "id": 818, "name": "Alyutamah", "centerLat": 23.8, "centerLng": 39.8, "point1Lat": 23.86, "point1Lng": 39.86, "point2Lat": 23.74, "point2Lng": 39.74
    },
    {
        "id": 819, "name": "Wadi Al Fora", "centerLat": 23.5, "centerLng": 39.2, "point1Lat": 23.56, "point1Lng": 39.26, "point2Lat": 23.44, "point2Lng": 39.14
    },
    {
        "id": 820, "name": "Al Akhal", "centerLat": 23.2, "centerLng": 39.5, "point1Lat": 23.26, "point1Lng": 39.56, "point2Lat": 23.14, "point2Lng": 39.44
    },
    {
        "id": 821, "name": "Al Musayjid", "centerLat": 24.1, "centerLng": 39, "point1Lat": 24.16, "point1Lng": 39.06, "point2Lat": 24.04, "point2Lng": 38.94
    },
    {
        "id": 822, "name": "Ad Dumayriyah", "centerLat": 25.1, "centerLng": 40.8, "point1Lat": 25.16, "point1Lng": 40.86, "point2Lat": 25.04, "point2Lng": 40.74
    },
    {
        "id": 823, "name": "Al Harara", "centerLat": 22, "centerLng": 42.5, "point1Lat": 22.06, "point1Lng": 42.56, "point2Lat": 21.94, "point2Lng": 42.44
    },
    {
        "id": 824, "name": "Qena", "centerLat": 18.73, "centerLng": 42.02, "point1Lat": 18.79, "point1Lng": 42.08, "point2Lat": 18.67, "point2Lng": 41.96
    },
    {
        "id": 825, "name": "almujasuh", "centerLat": 26.5, "centerLng": 40.5, "point1Lat": 26.56, "point1Lng": 40.56, "point2Lat": 26.44, "point2Lng": 40.44
    },
    {
        "id": 826, "name": "am shieari", "centerLat": 26.2, "centerLng": 40.3, "point1Lat": 26.26, "point1Lng": 40.36, "point2Lat": 26.14, "point2Lng": 40.24
    },
    {
        "id": 827, "name": "alashqur", "centerLat": 26, "centerLng": 40.1, "point1Lat": 26.06, "point1Lng": 40.16, "point2Lat": 25.94, "point2Lng": 40.04
    },
    {
        "id": 828, "name": "Abu suhailat", "centerLat": 25.8, "centerLng": 39.9, "point1Lat": 25.86, "point1Lng": 39.96, "point2Lat": 25.74, "point2Lng": 39.84
    },
    {
        "id": 829, "name": "Bujilh", "centerLat": 25.6, "centerLng": 39.7, "point1Lat": 25.66, "point1Lng": 39.76, "point2Lat": 25.54, "point2Lng": 39.64
    },
    {
        "id": 830, "name": "Bada Bin Khalf", "centerLat": 25.4, "centerLng": 39.5, "point1Lat": 25.46, "point1Lng": 39.56, "point2Lat": 25.34, "point2Lng": 39.44
    },
    {
        "id": 831, "name": "Alshuwayms", "centerLat": 25.2, "centerLng": 39.3, "point1Lat": 25.26, "point1Lng": 39.36, "point2Lat": 25.14, "point2Lng": 39.24
    },
    {
        "id": 832, "name": "Albarqh", "centerLat": 25, "centerLng": 39.1, "point1Lat": 25.06, "point1Lng": 39.16, "point2Lat": 24.94, "point2Lng": 39.04
    },
    {
        "id": 833, "name": "Alwaseah", "centerLat": 24.8, "centerLng": 38.9, "point1Lat": 24.86, "point1Lng": 38.96, "point2Lat": 24.74, "point2Lng": 38.84
    },
    {
        "id": 834, "name": "Al Aradiah", "centerLat": 19.248, "centerLng": 41.636, "point1Lat": 19.3, "point1Lng": 41.69, "point2Lat": 19.18, "point2Lng": 41.57
    },
    {
        "id": 835, "name": "Himah", "centerLat": 25.9, "centerLng": 41, "point1Lat": 25.96, "point1Lng": 41.06, "point2Lat": 25.84, "point2Lng": 40.94
    },
    {
        "id": 836, "name": "Alhalifh Alsufla", "centerLat": 25.5, "centerLng": 40.8, "point1Lat": 25.56, "point1Lng": 40.86, "point2Lat": 25.44, "point2Lng": 40.74
    },
    {
        "id": 837, "name": "Alhalifh Alalya", "centerLat": 25.8, "centerLng": 40.9, "point1Lat": 25.86, "point1Lng": 40.96, "point2Lat": 25.74, "point2Lng": 40.84
    },
    {
        "id": 838, "name": "Badayie Albadia", "centerLat": 24.5, "centerLng": 43.5, "point1Lat": 24.56, "point1Lng": 43.56, "point2Lat": 24.44, "point2Lng": 43.44
    },
    {
        "id": 839, "name": "Abu Suwysat", "centerLat": 24.3, "centerLng": 43.7, "point1Lat": 24.36, "point1Lng": 43.76, "point2Lat": 24.24, "point2Lng": 43.64
    },
    {
        "id": 840, "name": "Al dabia", "centerLat": 26.116667, "centerLng": 49.633333, "point1Lat": 26.13, "point1Lng": 49.65, "point2Lat": 26.1, "point2Lng": 49.61
    },
    {
        "id": 841, "name": "Qaryat you Albaha", "centerLat": 20, "centerLng": 41.6, "point1Lat": 20.06, "point1Lng": 41.66, "point2Lat": 19.94, "point2Lng": 41.54
    },
    {
        "id": 842, "name": "Adowat Athqub", "centerLat": 24.1, "centerLng": 44, "point1Lat": 24.16, "point1Lng": 44.06, "point2Lat": 24.04, "point2Lng": 43.94
    },
    {
        "id": 843, "name": "Shueayb Alqarn", "centerLat": 23.9, "centerLng": 44.3, "point1Lat": 23.96, "point1Lng": 44.36, "point2Lat": 23.84, "point2Lng": 44.24
    },
    {
        "id": 844, "name": "Al Raqi", "centerLat": 29, "centerLng": 46.5, "point1Lat": 29.06, "point1Lng": 46.56, "point2Lat": 28.94, "point2Lng": 46.44
    },
    {
        "id": 845, "name": "Dos", "centerLat": 20.2, "centerLng": 41.3, "point1Lat": 20.26, "point1Lng": 41.36, "point2Lat": 20.14, "point2Lng": 41.24
    },
    {
        "id": 846, "name": "الريث", "centerLat": 17.48, "centerLng": 43, "point1Lat": 17.54, "point1Lng": 43.06, "point2Lat": 17.42, "point2Lng": 42.94
    },
    {
        "id": 847, "name": "Al Salamah", "centerLat": 21.64, "centerLng": 39.16, "point1Lat": 21.7, "point1Lng": 39.22, "point2Lat": 21.58, "point2Lng": 39.1
    }
];